//*** Import react library
import React, { useEffect, useState, useRef, useCallback } from "react";
import Modal from 'react-bootstrap/Modal';
import Axios from 'axios'
import mqtt from "mqtt/dist/mqtt";
import "../../Assets/Styles/robot.css";
import 'bootstrap/dist/css/bootstrap.css';
import Iframe from "react-iframe";
import bg from "../../Assets/Images/robot_background.jpg";
import robot_operation from "../../Assets/Images/robot_operation.jpeg";
import cameraon from "../../Assets/Images/Camera_on.png";
import cameraoff from "../../Assets/Images/Camera_off.png";
import BatteryGauge from 'react-battery-gauge'
import "../../Assets/Styles/PowerLamp.css";
import "../../Assets/Styles/Switch.css";
import AxiosInstance from '../Axios/AxiosInstance';
import { handleMQTTError, handleAxiosError, handleGeneralError, handleTryCatchError } from '../ErrorHandler/errorHandler';
import { RobotRow } from "../RobotOperation/RobotRow";
import { TankLevel } from "../RobotOperation/TankLevel";
import { useNavigate } from "react-router-dom";
// ── Joystick / Direction Pad / Speed controller (used inside the "Robot Operations" popup) ──
// !! Adjust these 3 paths to the folder where your Joystick components live
//    (the same folder as the Index.jsx of the single-robot page).
import VirtualJoystick from "../Joystick/VirtualJoystick";
import SpeedSlider from "../Joystick/SpeedSlider";
import DPad from "../Joystick/DPad";

//******** Start WebRTC KVS

// Import AWS's official WebRTC helper — this handles talking to AWS
import { SignalingClient, Role } from 'amazon-kinesis-video-streams-webrtc';

// Import AWS tools to find our "channel" (the Pi's video address on AWS)
import { KinesisVideoClient, DescribeSignalingChannelCommand, GetSignalingChannelEndpointCommand } from '@aws-sdk/client-kinesis-video';

// Import AWS tool to get STUN/TURN servers (helps two devices connect)
import { KinesisVideoSignalingClient, GetIceServerConfigCommand } from '@aws-sdk/client-kinesis-video-signaling';

// Reminder: before running this, install these packages with npm install
// npm install amazon-kinesis-video-streams-webrtc @aws-sdk/client-kinesis-video @aws-sdk/client-kinesis-video-signaling

// --- Session-persisted caching --------------------------------------------
// The channel ARN/endpoints and the ICE server list are cached in memory
// (see channelCacheRef/iceServersCacheRef further down) so a reconnect
// doesn't re-ask AWS for things that haven't changed. Mirroring that cache
// into sessionStorage means it also survives a page refresh — sessionStorage
// persists for the life of the browser tab and clears automatically when the
// tab actually closes, which is exactly the lifetime we want here (longer
// than "just this component instance", but not forever).
const SESSION_STORAGE_CHANNEL_KEY = 'piviewer:channelCache';
const SESSION_STORAGE_ICE_KEY = 'piviewer:iceServersCache';

// All sessionStorage access is wrapped in try/catch: some browsers throw
// (rather than silently no-op) when storage is disabled or full — e.g.
// private/incognito mode in some cases — and this cache is purely an
// optimization, so any failure here should just mean "skip the cache",
// never break the actual connection.
function loadFromSessionStorage(key) {
    try {
        const raw = sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        console.log(`[PiViewer] sessionStorage read failed for ${key} — continuing without cache`, e);
        return null;
    }
}

function saveToSessionStorage(key, value) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.log(`[PiViewer] sessionStorage write failed for ${key} — cache just won't survive a refresh`, e);
    }
}

function clearSessionStorage(key) {
    try {
        sessionStorage.removeItem(key);
    } catch (e) {
        // Nothing meaningful to do if even this fails — not worth logging noise for.
    }
}
// ---------------------------------------------------------------------------

// --- Configuration (hardcoded for testing) -----------------------------
// Warning: these are just for testing on your own computer, not for
// putting online for everyone to see (explained more below)
// A permanent key embedded in browser code is visible to anyone who opens
// DevTools, and it never expires on its own like a temporary STS token
// would — so if this ships, rotate the key immediately in the IAM console.

// The name of the AWS "channel" your Raspberry Pi is broadcasting to
const CHANNEL_NAME = 'BhuSignaling';

// Which AWS data center location you are using//const REGION = 'us-west-2';
const REGION = 'ap-south-1';


// Your AWS login details (like a username and password for AWS)
const CREDENTIALS = {
    accessKeyId: 'AKIA2XJFAMI3NQKWRTR3',// old key  'AKIA2XJFAMI3LDGF7ZSE', // like a username
    secretAccessKey: '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'// old key '31yZRFh9thYZLXSCJp35rDrspdziNSNZlgaYtB7Q', // like a password
};

// A random unique name for this viewer, so AWS can tell viewers apart.
// IMPORTANT: this is called fresh for every connection attempt (see
// startViewing below) rather than computed once — reusing the same
// clientId across every reconnect risked colliding with AWS's own
// teardown of the previous session using that same id (AWS documents a
// ~1 minute grace period after telling a client to disconnect before
// that connection is actually torn down server-side).
function makeClientId() {
    return 'react-viewer-' + Math.random().toString(36).slice(2, 10);
}

// A list of possible states this component can be in, written as words
// instead of typing the same text many times (avoids typos)
const STATUS = {
    IDLE: 'idle',           // nothing happening yet, waiting for button click
    CONNECTING: 'connecting', // trying to connect right now
    LIVE: 'live',            // connected, video is playing
    RECONNECTING: 'reconnecting', // connection dropped (e.g. mobile NAT timeout), rebuilding automatically
    CLOSED: 'closed',        // connection was closed/lost (user pressed Stop)
};

// Mobile carrier NAT (CGNAT) commonly drops "idle" UDP mappings around the
// ~30s mark, which kills the WebRTC path even though both sides are fine.
// There's no way to resuscitate the existing connection once that happens,
// so instead we detect it fast and transparently rebuild a fresh session.
// These control how eagerly we retry after a drop.
const RECONNECT_BASE_DELAY_MS = 1000;   // first retry waits ~1s
const RECONNECT_MAX_DELAY_MS = 10000;   // never wait longer than 10s between tries

// We never permanently give up retrying on our own — an unattended robot
// camera may have no one watching to click "Watch Stream" again, and the
// Pi's own reconnect loop can legitimately take well over a minute. This
// constant only controls when we switch from logging every attempt to
// logging quietly (see QUIET_RETRY_LOG_EVERY) so a long outage doesn't
// flood the event log.
const RECONNECT_MAX_ATTEMPTS = 8;

// Once past RECONNECT_MAX_ATTEMPTS, only log a "still retrying" heartbeat
// every Nth attempt. At the 10s capped delay, 6 attempts ≈ once a minute.
const QUIET_RETRY_LOG_EVERY = 6;

// The channel ARN and its WSS/HTTPS endpoints don't change for a given
// channel name — there's no need to ask AWS for them again on every single
// reconnect. Only the TURN credentials from GetIceServerConfig actually
// expire (each server has its own Ttl in seconds). Caching both is the
// single biggest reconnect-speed win: on a real reconnect, these two calls
// were the slowest part by far (they're what timed out in the 8s/23s
// budgets). We just refetch ICE servers a bit before they'd actually
// expire, using this safety margin.
const ICE_SERVERS_REFRESH_MARGIN_MS = 30000;
const ICE_SERVERS_DEFAULT_TTL_S = 300; // sane fallback if AWS doesn't return a Ttl

// EXPERIMENTAL: AWS documents an idle-connection timeout (~10 minutes) on
// these signaling WebSockets — once the SDP/ICE handshake is done, no more
// signaling traffic normally flows, so the socket goes idle and AWS closes
// it. This periodically resends the last known local ICE candidate (using
// the signaling client's own public sendIceCandidate() method — there's no
// documented "ping"/keepalive API) purely to keep the WSS socket non-idle.
// AWS doesn't document whether this actually resets their idle timer, so
// treat this as a real attempt, not a guarantee — the reconnect logic above
// is still what actually recovers the stream if the connection drops
// anyway, keepalive or not.
const SIGNALING_KEEPALIVE_INTERVAL_MS = 4 * 60 * 1000; // 4 minutes — well under the ~10 minute idle limit

// Separate problem from a dropped ICE path: sometimes the connection stays
// "connected" (keepalives still succeed) but actual video frames stop
// arriving — the picture just freezes while status still says "live".
// This watchdog polls decoder stats directly so a frozen feed gets caught
// even when iceConnectionState/connectionState never change.
const STALL_CHECK_INTERVAL_MS = 1000;   // how often to check the frame counter
const STALL_MAX_STALE_CHECKS = 3;       // ~3s of zero new frames before we force a reconnect

// On mobile data, a single attempt can get stuck for a long time — not
// because our code is slow, but because one of the AWS SDK calls (or the
// signaling WebSocket's own open()) can hang waiting on a dead connection
// with no timeout of its own. If the SETUP phase (AWS calls through
// opening the signaling socket and sending our SDP offer) hasn't produced
// an answer within this window, something is genuinely stuck — give up
// and let the backoff loop retry.
const SETUP_TIMEOUT_MS = 8000;

// Once we've received the SDP answer, we know signaling is fine and real
// ICE/TURN negotiation is underway — that alone can legitimately take
// longer on mobile (relay allocation, connectivity checks across candidate
// pairs), so it gets its own, longer budget rather than sharing the setup
// timeout above.
const ICE_TIMEOUT_MS = 15000;

//*********** END WebRTC KVS

/*import { Helmet } from 'react-helmet';*/
//import { RobotLocation } from "../RobotOperation/RobotLocation";
//import Logger from "../ErrorLogger/LogConfig"
//import { MQTT } from "../RobotOperation/MQTT";
//import { Client_subscribe_to_mqtt_topic } from "../RobotOperation/MQTT";
//import { Create_broadcasting_command_message } from "../RobotOperation/MQTT";
//import { send_command_message_to_robot } from "../RobotOperation/MQTT";
//import { CaptureCamera } from "../RobotOperation/MQTT";
// MQTT code
///***Use anyone MQTT Broker
///***Use anyone MQTT Broker
//const url = 'tcp:/ / broker.emqx.io: 1883 / mqtt'
//const url = 'tls tcp:/ / broker.emqx.io: 8883 / mqtt'
//const url = 'ws://broker.emqx.io:8083/mqtt'
//const url = 'wss://broker.emqx.io:8084/mqtt'
//const url = 'tcp://broker.mqttdashboard.com:1883/mqtt'
//const url = 'tcp://broker.mqttdashboard.com:1883/mqtt'
//const url = 'ws://broker.mqttdashboard.com:8080/mqtt
//const url = 'tcp://broker.hivemq.com:1883/mqtt'
//const url = 'ws://broker.hivemq.com:8000/mqtt'
//const url = 'tls tcp://broker.hivemq.com:8883/mqtt'
//const url = 'wss://broker.hivemq.com:8884/mqtt'
//const url = 'ws://test.mosquitto.org:8080/mqtt'
//const url = 'mqtt://test.mosquitto.org:1883'
//const url = 'mqtt://localhost:1883/mqtt'
//const url = 'wss://test.mosquitto.org:8081/mqtt'
//const url = 'wss://mqtt-dashboard.com:8884/mqtt'
//mqtt - dashboard.com
const url = 'wss://c7cd69d47ed34850b8238e53f74566f2.s1.eu.hivemq.cloud:8884/mqtt'
//*** Global variables ***//
//const url = 'wss://broker.hivemq.com:8883/mqtt'
//*** Global variables ***//
var PlantID = sessionStorage.getItem("user_plantid");
const sruserID = sessionStorage.getItem("user_id");
const MQTT_Subscribe_Topic = "zylv4u8fun1";
const MQTT_Receiver_Topic = "e1ypuwron21";
var SubscribtionStatus = false;
var Current_command_status = null;
var Current_motor_speed_status = null;
var Current_turn_status = null;
var Current_grass_cutter_status = null;
var Current_controller_battery_status = null;
var Current_motor_battery_status = null;
var Current_sprayer_status = null;
var Current_sowing_status = null;
var IPAddress = null; //"http://192.168.1.9:8888/";
var RobotID;
var angle = 0;
let startTime = 0
///***
// * for Support url -https://www.emqx.com/en/blog/mqtt-js-tutorial
// * Browser
// * Using MQTT over WebSocket with ws and wss protocols
// * EMQX's ws connection default port is 8083, wss is 8084
// * Note that you need to add a path after the connection address, such as /mqtt
// */
//const url = 'ws://broker.emqx.io:8083/mqtt'
///***
// * Node.js
// * Using MQTT over TCP with mqtt and mqtts protocols
// * EMQX's mqtt connection default port is 1883, mqtts is 8883
// */
//const url = 'mqtt://broker.emqx.io:1883'
//const clientId = 'mqttjs_' + Math.random().toString(16).substr(2, 8)
//const clientId = 'c7cd69d47ed34850b8238e53f74566f2'
const clientId = 'mqttjs_eGuru123$@'
//**** Set options parameters of mqtt ***//
const options = {
    //*** clean session,
    //clean: true,
    keepalive: 120,//36000,//default 60 seconds alive 
    //connectTimeout: 72000,
    //protocol:'tcp',
    //reconnect: true,
    //reconnectPeriod: 500,
    protocolVersion: 5,
    //*** Create Client Id
    clientId,
    //clientId: `mqttjs_${Math.random().toString(16).substr(2, 8)}`, //can be changed for something more specific if you need it
    // username:null, //'eGuru',
    // password:null,// 'eGuru123$@',
    username: 'hivemq.webclient.1741693400426',
    password: '9L%7,vs!48zAEPihBkD@'
    //rejectUnauthorized: false
}
//*** Step-1 ***//
//*** Connect To MQTT broker ***//
//CONNECT packet is usedto initiate a connection to the server,
const client1 = mqtt.connect(url, options)
//const client1=""
//Triggered when the connection is successful, and the parameter is connack
client1.on('connect', function (err) {
    if (err) {
        var srPlantID = sessionStorage.getItem("user_plantid");
        var srUserID = sessionStorage.getItem("user_id");
        console.log("Not Connected To MQTT Broker" + err);
        //20250923   handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(connect)", "0x05", "ECONNREFUSED:Connection refused by the broker", "MQTT_CONNECTION_REFUSED_ERROR", "01", "www.bhuhit.com", "SE-F-1002");
        //  showInfoBox("dvInfoBox", 0, "Not Connected To MQTT Broker","MQTT_CONNECTIVITY");
    }
    if (!err) {
        console.log("Connected To MQTT Broker");
        SubscribtionStatus = Client_subscribe_to_mqtt_topic();
        //20250923 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(connect)", 0x00, "Connection Accepted: MQTT Connected", "CONNECTION_ACCEPTED", "03", "www.bhuhit.com", "SE-F-1002");
        client1.ping();
        client1.on('pingresp', () => {
            console.log('Received PINGRESP packet')
        });
    }
});

//CONNACK packet is sent as a response to indicate the result of the connection.
client1.on('connack', (packet) => {
    var srPlantID = sessionStorage.getItem("user_plantid");
    var srUserID = sessionStorage.getItem("user_id");

    if (packet.returnCode === 0) {
        console.log("Connection Accepted");
        //2025-06-25 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(connack)", 0x00, "Connection Accepted: MQTT Connected", "CONNECTION_ACCEPTED", "03", "www.bhuhit.com", "SE-F-1002");
    }
    else if (packet.returnCode === 1) {
        console.log("Connection Refused: unacceptable protocol version")
        //2025-06-25  handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(connack)", 0x01, "Connection refused: unacceptable protocol version", "CONNECTION_REFUSED", "01", "www.bhuhit.com", "SE-F-1002");
    }
    else if (packet.returnCode === 2) {
        console.log("Connection Refused: identifier rejected")
        //2025-06-25  handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(connack)", 0x02, "Connection refused: identifier rejected", "CONNECTION_REFUSED", "01", "www.bhuhit.com", "SE-F-1002");
    }
    else if (packet.returnCode === 3) {
        console.log("Connection Refused: Server unavailable")
        //2025-06-25  handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(connack)", 0x03, "Connection refused: Server unavailable", "CONNECTION_REFUSED", "01", "www.bhuhit.com", "SE-F-1002");
    }
    else if (packet.returnCode === 4) {
        console.log("Connection Refused: bad user name or password")
        //2025-06-25  handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(connack)", 0x04, "Connection refused: bad user name or password", "CONNECTION_REFUSED", "01", "www.bhuhit.com", "SE-F-1002");
    }
    else if (packet.returnCode === 5) {
        console.log("Connection Refused:not unauthorised")
        //2025-06-25 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(connack)", 0x05, "Connection refused: not unauthorised", "CONNECTION_REFUSED", "01", "www.bhuhit.com", "SE-F-1002");
    }
});

//Triggered when the client cannot connect successfully or a parsing error occurs.The parameter error is the error message
client1.on('error', (err) => {
    console.log('error!' + err)
    var srPlantID = sessionStorage.getItem("user_plantid");
    var srUserID = sessionStorage.getItem("user_id");
    //# MQTT Error Codes
    //1. 0x00: Connection Accepted(success)
    // 2. 0x01: Connection Refused, unacceptable protocol version
    // 3. 0x02: Connection Refused, identifier rejected
    // 4. 0x03: Connection Refused, Server unavailable
    //  5. 0x04: Connection Refused, bad user name or password
    //  6. 0x05: Connection Refused, not authorized

    //# MQTT Error Types
    // 1. Connection Errors: Errors related to establishing or maintaining a connection to the MQTT broker.
    //- ECONNREFUSED: Connection refused by the broker.
    // - ETIMEDOUT: Connection timed out.
    //2. Message Errors: Errors related to sending or receiving messages.
    // - EINVALIDMSG: Invalid message format or payload.
    // - EMSGSIZE: Message size exceeds the maximum allowed size.
    //3. Broker Errors: Errors related to the MQTT broker.
    // - EBROKERUNAVAILABLE: Broker is unavailable or not responding.
    switch (err.code) {
        // 1. Connection Errors: Errors related to establishing or maintaining a connection to the MQTT broker.
        case 'ECONNREFUSED':
            console.log('ECONNREFUSED:Connection refused by the broker');
            //2025-06-25 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(error)", err.code, "ECONNREFUSED:Connection refused by the broker","MQTT_CONNECTION_REFUSED_ERROR", "01","www.bhuhit.com","SE-F-1002");
            break;
        case 'ETIMEDOUT':
            console.log('ETIMEDOUT:Connection timed out');
            //2025-06-25 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(error)", err.code, "ETIMEDOUT:Connection timed out", "MQTT_CONNECTION_TIME_OUT_ERROR", "01", "www.bhuhit.com", "SE-F-1002");
            break;
        // 2. Message Errors: Errors related to sending or receiving messages.
        case 'EINVALIDMSG':
            console.log('EINVALIDMSG: Invalid message format or payload.');
            //2025-06-25 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(error)", err.code, "EINVALIDMSG: Invalid message format or payload.", "MQTT_INVALID_MESSAGE_ERROR", "01", "www.bhuhit.com", "SE-F-1002");
            break;
        case 'EMSGSIZE':
            console.log('EMSGSIZE: Message size exceeds the maximum allowed size.');
            //2025-06-25 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(error)", err.code, "EMSGSIZE: Message size exceeds the maximum allowed size.", "MQTT_MESSAGE_SIZE_EXCEED", "01", "www.bhuhit.com", "SF-1000");
            break;
        //3. Broker Errors: Errors related to the MQTT broker.
        case 'EBROKERUNAVAILABLE':
            console.log('EBROKERUNAVAILABLE: Broker is unavailable or not responding.');
            //2025-06-25  handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(error)", err.code, "EBROKERUNAVAILABLE: Broker is unavailable or not responding.", "MQTT_BROKER_UNAVAILABLE", "01", "www.bhuhit.com", "SF-1000");
            break;
        default:
            console.log('Unknown error:', err);
        //2025-06-25 handleMQTTError(srPlantID, 0,"RobotOperation.js", "client1.on(error)", err.code, "Unknown error", "Unknown error", "01", "www.bhuhit.com", "SF-F-1002");
    }
    client1.end()
});

// Triggered after disconnection
client1.on('close', () => {
    console.log(clientId + ' disconnected')
    var srPlantID = sessionStorage.getItem("user_plantid");
    var srUserID = sessionStorage.getItem("user_id");
    //20250923 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(close)", "BROKERDISCONNECTED", "BROKERDISCONNECTED:BrokerDisconnected", "MQTT_BROKER_DISCONNECTED",  "01", "www.bhuhit.com", "SF-F-1002");
    // client1.end()
})

//Triggered when a disconnected packet sent by broker is received, and the parameter packet is the packet received when disconnected.
//It is a new function in MQTT 5.0
//If one wants to terminate the communication or encounters an error 
//that requires terminating the connection, the client and server can send a DISCONNECT packet and 
//then close the network connection.
//client1.on('disconnect', function (packet) {
//   // console.log(packet)
//})
// Display Operation Modal Popup
function showInfoBox(dvInfoBox, robotID, errorMessage, errorType) {
    //setIsModalOpen(true);
    var divInfoBox = document.getElementById(dvInfoBox);
    var lblMsg = document.getElementById("lblCriticalMsg");
    divInfoBox.style.display = "block";
    lblMsg.value = errorMessage;
    //setSentCommandButtonActive("btnGetMore" + robotID, robotID, "divGetMore" + robotID, "SendCommand")
};
// Hide Operation Modal Popup  
const hideInfoBox = (dvInfobox) => {
    //setIsModalOpen(false);
    var dvimodal = document.getElementById(dvInfobox);
    dvimodal.style.display = "none";
};
//*** Subscribe to MQTT topic
export const Client_subscribe_to_mqtt_topic = () => {
    var srPlantID = sessionStorage.getItem("user_plantid");
    var srUserID = sessionStorage.getItem("user_id");
    var subscribe_topic;
    try {
        //*** Subescribe to Pblish Topic 'zylv4u8fun' ***//
        client1.subscribe(MQTT_Subscribe_Topic, function (err) {
            if (!err) {
                console.log('Client Subscribed to MQTT Pblish Topic')
                SubscribtionStatus = true;
                //20250923 handleMQTTError(srPlantID, 0, "RobotOperation.js", "Client_subscribe_to_mqtt_topic", "CLIENTPUBLISHSUBSCRIPTIONERROR", "SUBSCRIPTION ERROR:Client not Subscribed to MQTT Pblish Topic", "CLIENT_PUBLISH_SUBSCRIPTION_SUCCESS", "01", "www.bhuhit.com", "SE-F-1002");
            }
            if (err) {
                console.log('Client not Subscribed to MQTT Pblish Topic')
                SubscribtionStatus = false;
                //20250923handleMQTTError(srPlantID, 0, "RobotOperation.js", "Client_subscribe_to_mqtt_topic", "CLIENTPUBLISHSUBSCRIPTIONERROR", "SUBSCRIPTION ERROR:Client not Subscribed to MQTT Pblish Topic", "CLIENT_PUBLISH_SUBSCRIPTION_ERROR", "01", "www.bhuhit.com", "SE-F-1002");
            }
        })
        subscribe_topic = MQTT_Subscribe_Topic;
        //*** Subscribe to message receiver topic ***//
        client1.subscribe(MQTT_Receiver_Topic, function (err1) {
            if (!err1) {
                console.log('Client Subscribed to MQTT receiver topic')
                SubscribtionStatus = true;
            }
            if (err1) {
                console.log('Client not Subscribed to MQTT receiver topic')
                client1.subscribe(MQTT_Receiver_Topic);
                SubscribtionStatus = false;
                //20250923 handleMQTTError(srPlantID, 0, "RobotOperation.js", "client1.on(error)", "CLIENTSUBSCRIPTIONERROR", "CLIENTRECEIVERSUBSCRIPTIONERROR:Client not Subscribed to MQTT receiver topic", "CLIENT_RECEIVER_SUBSCRIPTION_ERROR", "01", "www.bhuhit.com", "SE-F-1002");
            }
        })
        subscribe_topic = subscribe_topic + "," + MQTT_Subscribe_Topic;
        return SubscribtionStatus;
    }
    catch (err) {
        SubscribtionStatus = false;
        console.log("Error to Subscribe Task: " + err.message + "");
        // handleMQTTError(srPlantID, 0,"RobotOperation.js", "client1.on(error)", err.code, err.type, "Error to Subscribe Task:"+err.message+"", "Client Subscription Error", "01", "www.bhuhit.com", "SF-F-1002");
        //handleTryCatchError(err, "RobotOperation.js", "client1.on(error)")
    }
};


//*** Step-3 ***//
/***Send broadcasting frames to robots ***/
function Send_broadcasting_command_message_to_robot(Broadcasting_command_msg, robotID) {
    try {
        var PlantID = sessionStorage.getItem("user_plantid");
        var sruserID = sessionStorage.getItem("user_id");
        Client_subscribe_to_mqtt_topic();
        //*** Send MQTT Broadcasting Message to Robot ***//
        client1.publish(MQTT_Subscribe_Topic, Broadcasting_command_msg)
        console.log("Step-1 (Broadcasting): Operator have sent Robot ID " + robotID + " to Robot and have completed step 1/6.");
    }
    catch (e) {
        //handleMQTTError(PlantID, robotID,"RobotOperation.js", "Send_broadcasting_command_message_to_robot", e.code, e.type, "Error to Broadcasting Robot:" + robotID + "" + e.message + "", "Robot Broadcasting Publish Error", "01", "www.bhuhit.com", "SF-F-1002");
        //handleTryCatchError(e, "RobotOperation.js", "client1.on(error)")
        console.log("Step-1 (Broadcasting) Error: " + e.message + "");
    }
}

//*** Set global variables status null or false ***//
//function Set_Variables_Status() {
//    Current_command_status = null;
//    Current_turn_status = null;
//    Current_motor_speed_status = null;
//    Current_grass_cutter_status = null;
//    Current_sprayer_status = null;
//}
//*** ================= Joystick / Direction Pad / Speed controller + page control bars ================= ***//
const DRIVE_DEADZONE = 0.14;

// Joystick -> robot command.  Cmd: F / B / S (never L or R)   Turn: L / R / D
function driveDeriveCmd(x, y) {
    if (Math.abs(x) <= DRIVE_DEADZONE && Math.abs(y) <= DRIVE_DEADZONE) return { c: 'S', t: 'D' };
    let c = 'S', t = 'D';
    if (Math.abs(y) > DRIVE_DEADZONE) c = y < 0 ? 'F' : 'B';
    if (Math.abs(x) > 0.3) t = x < 0 ? 'L' : 'R';
    return { c, t };
}

// The Joystick / DPad / Speed components use these CSS variables (defined here so they do not
// depend on any global theme).
const DRIVE_CSS_VARS = {
    '--bg-panel': '#ffffff', '--bg-card': '#f6f6f6', '--bg-inset': '#f6f6f6',
    '--border': '#d0d4d8', '--border-lit': '#aab2ba',
    '--text': '#1f2933', '--text-dim': '#1f2933', '--label': '#1f2933',
    '--accent': '#8dbd2a', '--accent-rgb': '141, 189, 42', '--accent2': '#ff7b00', '--accent3': '#1fa64a', '--accent4': '#e5173f', '--warn': '#e0a100',
    '--speed-fill': 'linear-gradient(90deg,#3f6212,#6f9a1a,#8dbd2a)', '--speed-ink': '#3f6212', '--speed-glow': 'none',
    '--glow': '0 0 10px rgba(141,189,42,.5)', '--glow3': '0 0 8px rgba(31,166,74,.5)', '--glow4': '0 0 8px rgba(229,23,63,.5)',
};

/*
 * useDriveInput — Joystick + Direction Pad input handling.
 *   onDrive(cmd, turn, speed) is called for every command; the page decides which robots receive it.
 *   Timing rules:
 *     STOP        : instant (cancels every pending timer)
 *     Joystick F/B: 200 ms throttle
 *     Joystick L/R: turn-in-place, delayed (first 500 ms, then 1 s while held)
 *     D-Pad       : hold = drive, release = STOP   (L/R after 800 ms)
 */
function useDriveInput(onDrive, speed) {
    const speedRef = useRef(speed);
    const onDriveRef = useRef(onDrive);
    const joyRef = useRef({ x: 0, y: 0 });
    const timerRef = useRef(null);      // F/B throttle
    const lrTimerRef = useRef(null);    // L/R delay
    const lrFiredRef = useRef(false);
    speedRef.current = speed;
    onDriveRef.current = onDrive;

    const send = useCallback((c, t, spd) => onDriveRef.current(c, t, spd), []);
    const clearTimers = () => {
        if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; }
        if (lrTimerRef.current) { clearTimeout(lrTimerRef.current); lrTimerRef.current = null; }
    };

    const handleJoyMove = useCallback(({ x, y }) => {
        joyRef.current = { x, y };
        if (x === 0 && y === 0) { clearTimers(); lrFiredRef.current = false; send('S', 'D', 0); return; }
        const { c, t } = driveDeriveCmd(x, y);
        const turnInPlace = c === 'S' && (t === 'L' || t === 'R');
        if (turnInPlace) {
            if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; }
            if (!lrTimerRef.current) {
                const delay = lrFiredRef.current ? 1000 : 500;
                lrTimerRef.current = setTimeout(() => {
                    lrTimerRef.current = null;
                    lrFiredRef.current = true;
                    const snap = driveDeriveCmd(joyRef.current.x, joyRef.current.y);
                    if (snap.c === 'S' && (snap.t === 'L' || snap.t === 'R')) send(snap.c, snap.t, speedRef.current);
                }, delay);
            }
        } else {
            if (lrTimerRef.current) { clearTimeout(lrTimerRef.current); lrTimerRef.current = null; }
            lrFiredRef.current = false;
            if (timerRef.current) return;
            timerRef.current = setTimeout(() => {
                timerRef.current = null;
                const snap = driveDeriveCmd(joyRef.current.x, joyRef.current.y);
                send(snap.c, snap.t, speedRef.current);
            }, 200);
        }
    }, [send]);

    const DMAP = {
        F: { c: 'F', t: 'D' }, B: { c: 'B', t: 'D' },
        L: { c: 'S', t: 'L' }, R: { c: 'S', t: 'R' }, S: { c: 'S', t: 'D' },
    };
    const onDpadPress = useCallback((k) => {
        const { c, t } = DMAP[k];
        const turnInPlace = c === 'S' && (t === 'L' || t === 'R');
        if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; }
        if (turnInPlace) {
            if (!lrTimerRef.current) {
                lrTimerRef.current = setTimeout(() => { lrTimerRef.current = null; send(c, t, speedRef.current); }, 800);
            }
        } else {
            if (lrTimerRef.current) { clearTimeout(lrTimerRef.current); lrTimerRef.current = null; }
            send(c, t, k === 'S' ? 0 : speedRef.current);
        }
    }, [send]); // eslint-disable-line react-hooks/exhaustive-deps

    const onDpadRelease = useCallback(() => { clearTimers(); send('S', 'D', 0); }, [send]);

    // Controls removed while moving -> make sure the robots stop
    useEffect(() => () => {
        clearTimers();
        onDriveRef.current('S', 'D', 0);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return { handleJoyMove, onDpadPress, onDpadRelease };
}

// Time since the robot connected (counts HH:MM:SS; own 1 s timer so the whole list does not re-render every second)
function ConnectedTimer({ since }) {
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);
    return <span>{formatTime(Math.max(0, Math.floor((now - since) / 1000)))}</span>;
}

// One designed button
function RbBtn({ icon, label, variant, active, onClick, id, small, disabled, title }) {
    return (
        <button type="button" id={id} title={title || label} onClick={onClick} disabled={disabled}
            aria-pressed={active === undefined ? undefined : !!active}
            className={`rb-btn rb-${variant}${small ? ' rb-btn-sm' : ''}${active ? ' rb-active' : ''}`}>
            <i className={`fa ${icon}`} aria-hidden="true"></i>
            <span>{label}</span>
        </button>
    );
}

/*
 * RobotTopBar — slim toolbar at the top of the list:
 *   All · N selected · "Selected only" filter · Connect · Scan Farm · Charging · Parking · Stop · Off
 */
function RobotTopBar(p) {
    const pick = (label, fn) => (e) => { p.setSelectedCmd(label); fn(e); };
    return (
        <div className="rb-topbar">
            <div className="rb-topbar-left">
                <label className="rb-all">
                    <input type="checkbox" checked={p.masterChecked} onChange={p.onMasterCheck} />
                    <span>All</span>
                </label>
                <span className="rb-count">{p.selectedCount} selected</span>
                <button type="button" aria-pressed={!!p.showSelectedOnly} className={`rb-toggle${p.showSelectedOnly ? ' rb-toggle-on' : ''}`} onClick={p.onToggleSelectedOnly}
                    title="Show only the ticked robots so their cameras sit together">
                    <i className="fa fa-eye" aria-hidden="true"></i>&nbsp;Selected only
                </button>
            </div>
            <div className="rb-topbar-btns">
                <RbBtn small variant="green" icon="fa-plug" label={p.connectLabel} active={p.connectActive} onClick={p.onConnect} />
                <RbBtn small variant="blue" icon="fa-search" label="Scan Farm" onClick={p.onScanFarm} />
                <RbBtn small variant="blue" icon="fa-gamepad" label="Use Joystick" disabled={!p.joystickTargetName} onClick={p.onUseJoystick}
                    title={p.joystickTargetName ? "Open the Joystick page for " + p.joystickTargetName : "Tick ONE robot (or open a robot's More popup) to use its Joystick page"} />
                <RbBtn small variant="amber" icon="fa-bolt" label="Charging" active={p.selectedCmd === 'Charging'} onClick={pick('Charging', p.onCharging)} />
                <RbBtn small variant="slate" icon="fa-taxi" label="Parking" active={p.selectedCmd === 'Parking'} onClick={pick('Parking', p.onParking)} />
                <RbBtn small variant="red" icon="fa-stop-circle" label="Stop" active={p.selectedCmd === 'Stop'} onClick={pick('Stop', p.onStop)} />
                <RbBtn small variant="dark" icon="fa-power-off" label="Off" active={p.selectedCmd === 'Off'} onClick={pick('Off', p.onOff)} />
            </div>
        </div>
    );
}

/*
 * RobotControlDock — STICKY at the bottom of the screen, so the cameras above stay visible while driving.
 *   LEFT hand : Connect · Scan Farm · Charging · Parking  +  Speed controller
 *   RIGHT hand: Joystick + Direction Pad + Stop / Off
 *   "Hide controls" collapses it to a slim strip (Stop and Off stay available).
 */
function RobotControlDock(p) {
    const { handleJoyMove, onDpadPress, onDpadRelease } = useDriveInput(p.onDrive, p.speed);
    const pick = (label, fn) => (e) => { p.setSelectedCmd(label); fn(e); };
    const dockRef = useRef(null);
    const { onHeight } = p;
    // report the dock's real height (changes when collapsed / on small screens) so the popup can leave exactly that much room
    useEffect(() => {
        const el = dockRef.current;
        if (!el || !onHeight) return undefined;
        const report = () => onHeight(Math.round(el.offsetHeight));
        report();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const ro = new ResizeObserver(report);
        ro.observe(el);
        return () => ro.disconnect();
    }, [onHeight]);
    return (
        <div ref={dockRef} className={`rb-dock${p.showDrive ? '' : ' rb-dock-min'}`} style={DRIVE_CSS_VARS}>
            <div className="rb-dock-handle">
                <button type="button" className="rb-toggle" onClick={p.onToggleDrive}>
                    <i className="fa fa-gamepad" aria-hidden="true"></i>&nbsp;{p.showDrive ? 'Hide controls ▼' : 'Show controls ▲'}
                </button>
                <span className="rb-count">{p.selectedCount} selected</span>
                <span className={`rb-target ${p.selectedCount || p.hasPopupRobot ? '' : 'rb-target-warn'}`}>{p.targetLabel}</span>
                {!p.showDrive && (
                    <span className="rb-handle-btns">
                        <RbBtn small variant="red" icon="fa-stop-circle" label="Stop" onClick={pick('Stop', p.onStop)} />
                        <RbBtn small variant="dark" icon="fa-power-off" label="Off" onClick={pick('Off', p.onOff)} />
                    </span>
                )}
            </div>

            {p.showDrive && (
                <div className="rb-dock-body">
                    {/* ───────── LEFT HAND ───────── */}
                    <div className="rb-dock-left">
                        <div className="rb-row">
                            <RbBtn small variant="green" icon="fa-plug" label={p.connectLabel} active={p.connectActive} onClick={p.onConnect} />
                            <RbBtn small variant="blue" icon="fa-search" label="Scan Farm" onClick={p.onScanFarm} />
                            <RbBtn small variant="blue" icon="fa-gamepad" label="Use Joystick" disabled={!p.joystickTargetName} onClick={p.onUseJoystick}
                                title={p.joystickTargetName ? "Open the Joystick page for " + p.joystickTargetName : "Tick ONE robot (or open a robot's More popup) to use its Joystick page"} />
                            <RbBtn small variant="amber" icon="fa-bolt" label="Charging" active={p.selectedCmd === 'Charging'} onClick={pick('Charging', p.onCharging)} />
                            <RbBtn small variant="slate" icon="fa-taxi" label="Parking" active={p.selectedCmd === 'Parking'} onClick={pick('Parking', p.onParking)} />
                        </div>
                        <div className="rb-speed">
                            <SpeedSlider speed={p.speed} onChange={p.onSpeedChange} />
                        </div>
                    </div>

                    {/* ───────── RIGHT HAND ───────── */}
                    <div className="rb-dock-right">
                        <div className="rb-pad"><VirtualJoystick onMove={handleJoyMove} /></div>
                        <div className="rb-pad"><DPad onClick={onDpadPress} onPress={onDpadPress} onRelease={onDpadRelease} /></div>
                        <div className="rb-stack">
                            <RbBtn variant="red" icon="fa-stop-circle" label="Stop" active={p.selectedCmd === 'Stop'} onClick={pick('Stop', p.onStop)} />
                            <RbBtn variant="dark" icon="fa-power-off" label="Off" active={p.selectedCmd === 'Off'} onClick={pick('Off', p.onOff)} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// Styles for the bars, buttons and camera pills (rendered once by the page)
const RB_CSS = `
/* ═════════════ design tokens ═════════════ */
.rb-topbar,.rb-dock{
  --rb-ink:#1f2933; --rb-muted:#5b6770; --rb-line:#dde3e8; --rb-line-strong:#c5cdd4;
  --rb-surface:#ffffff; --rb-surface-2:#f6f8fa;
  --rb-brand:#8dbd2a; --rb-brand-soft:#eef5dc; --rb-brand-line:#d9e8b5;
  color:var(--rb-ink); font-family:inherit;
}
.rb-topbar *,.rb-dock *{box-sizing:border-box}

/* ═════════════ buttons — ONE consistent style ═════════════
   unselected : white, neutral border, coloured icon
   selected   : filled with the action's own colour (Stop = red, Off = dark ...)            */
.rb-btn{
  --c:#546e7a; --c-ink:#ffffff; --c-icon:#546e7a; --c-ring:rgba(84,110,122,.28);
  display:inline-flex !important; width:auto !important; flex:0 0 auto; align-items:center; justify-content:center;
  gap:8px; min-height:42px; padding:0 18px; margin:0;
  border-radius:10px; border:1px solid var(--rb-line-strong);
  background:var(--rb-surface); color:var(--rb-ink);
  font-family:inherit; font-weight:600; font-size:14px; letter-spacing:.1px; line-height:1; white-space:nowrap;
  cursor:pointer; user-select:none; -webkit-tap-highlight-color:transparent;
  box-shadow:0 1px 2px rgba(16,24,40,.06);
  transition:background-color .15s,border-color .15s,color .15s,box-shadow .15s,transform .08s;
}
.rb-btn i{font-size:15px;color:var(--c-icon);transition:color .15s}
.rb-btn-sm{min-height:38px;padding:0 14px;font-size:13.5px;gap:7px}
.rb-btn:hover{background:var(--rb-surface-2);border-color:var(--c-icon)}
.rb-btn:active{transform:translateY(1px);box-shadow:none}
.rb-btn:focus-visible{outline:3px solid rgba(0,168,214,.45);outline-offset:2px}
.rb-btn:disabled{opacity:.5;cursor:not-allowed;box-shadow:none;background:var(--rb-surface-2)}
.rb-btn:disabled:hover{border-color:var(--rb-line-strong)}
.rb-btn:disabled:active{transform:none}

/* identity colour of each action */
.rb-green{--c:#8dbd2a;--c-ink:#13210a;--c-icon:#5f8f1a;--c-ring:rgba(141,189,42,.38)}
.rb-blue {--c:#0b9ac4;--c-ink:#ffffff;--c-icon:#0b9ac4;--c-ring:rgba(11,154,196,.30)}
.rb-amber{--c:#ffc83d;--c-ink:#3b2f00;--c-icon:#d98a00;--c-ring:rgba(255,200,61,.42)}
.rb-slate{--c:#546e7a;--c-ink:#ffffff;--c-icon:#546e7a;--c-ring:rgba(84,110,122,.30)}
.rb-red  {--c:#e5173f;--c-ink:#ffffff;--c-icon:#e5173f;--c-ring:rgba(229,23,63,.30)}
.rb-dark {--c:#263238;--c-ink:#ffffff;--c-icon:#263238;--c-ring:rgba(38,50,56,.30)}

/* SELECTED */
.rb-btn.rb-active{background:var(--c);border-color:var(--c);color:var(--c-ink);box-shadow:0 0 0 3px var(--c-ring),0 2px 6px rgba(16,24,40,.18)}
.rb-btn.rb-active i{color:var(--c-ink)}
.rb-btn.rb-active:hover{background:var(--c);filter:brightness(1.05)}

/* ═════════════ small shared pieces ═════════════ */
.rb-all{display:flex;align-items:center;gap:8px;font-weight:700;font-size:15px;margin:0;cursor:pointer;color:var(--rb-ink)}
.rb-all input{width:20px;height:20px;accent-color:#6f9a1a;cursor:pointer;margin:0}
.rb-count{display:inline-flex;align-items:center;white-space:nowrap;background:var(--rb-brand-soft);color:#3f5f0c;border:1px solid var(--rb-brand-line);font-weight:700;font-size:12.5px;padding:4px 11px;border-radius:999px}
.rb-target{flex:1;min-width:140px;display:flex;align-items:center;gap:8px;font-size:13px;font-weight:600;color:#2f5d1a}
.rb-target::before{content:"";flex:0 0 auto;width:8px;height:8px;border-radius:50%;background:#3fa34d;box-shadow:0 0 0 3px rgba(63,163,77,.18)}
.rb-target-warn{color:#8a5a00}
.rb-target-warn::before{background:#e0a100;box-shadow:0 0 0 3px rgba(224,161,0,.2)}
.rb-toggle{width:auto !important;display:inline-flex;align-items:center;margin:0;border:1px solid var(--rb-line-strong);background:var(--rb-surface);color:var(--rb-ink);border-radius:8px;padding:7px 12px;font-family:inherit;font-weight:600;font-size:13px;line-height:1;cursor:pointer;box-shadow:0 1px 2px rgba(16,24,40,.06);transition:background-color .15s,border-color .15s}
.rb-toggle:hover{background:var(--rb-surface-2);border-color:#9aa5af}
.rb-toggle-on{background:var(--rb-brand);border-color:var(--rb-brand);color:#13210a}
.rb-toggle-on:hover{background:var(--rb-brand);filter:brightness(1.05)}

/* ═════════════ top bar ═════════════ */
.rb-topbar{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px 16px;background:var(--rb-surface);border:1px solid var(--rb-line);border-radius:14px;padding:10px 14px;margin:10px 0;box-shadow:0 1px 3px rgba(16,24,40,.07),0 1px 2px rgba(16,24,40,.04)}
.rb-topbar-left{display:flex;align-items:center;flex-wrap:wrap;gap:10px 14px}
.rb-topbar-btns{display:flex;align-items:center;flex-wrap:wrap;gap:8px}

/* ═════════════ sticky bottom dock ═════════════ */
.rb-dock{position:-webkit-sticky;position:sticky;bottom:0;z-index:3000;background:var(--rb-surface);border:1px solid var(--rb-line);border-top:3px solid var(--rb-brand);border-bottom:0;border-radius:16px 16px 0 0;box-shadow:0 -8px 24px rgba(16,24,40,.16);padding:10px 14px 12px;margin-top:10px;display:flex;flex-direction:column;gap:10px;
  --joy-size:112px;--joy-thumb:38px;--joy-hint:none;--joy-badge:70px;--dpad-btn:38px;--speed-track:32px;--speed-value:22px}
.rb-dock-handle{display:flex;align-items:center;flex-wrap:wrap;gap:8px 12px;padding-bottom:10px;border-bottom:1px solid var(--rb-line)}
.rb-dock-min .rb-dock-handle{padding-bottom:0;border-bottom:0}
.rb-handle-btns{display:flex;gap:8px;margin-left:auto}
.rb-dock-body{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:18px;align-items:center}
.rb-dock-left{display:flex;flex-direction:column;gap:10px;min-width:0}
.rb-row{display:flex;flex-wrap:wrap;gap:8px}
.rb-speed{width:100%;max-width:480px}
.rb-dock-right{display:flex;flex-wrap:wrap;gap:14px;align-items:center;justify-content:flex-end}
.rb-pad{display:flex;justify-content:center}
.rb-stack{display:flex;flex-direction:column;gap:8px}
.rb-stack .rb-btn{min-width:112px}
@media (min-width:821px){
  .rb-dock-right{padding-left:18px;border-left:1px solid var(--rb-line)}
}

/* ═════════════ camera / joystick pills (popup footer) ═════════════ */
.rb-pill{display:inline-flex !important;align-items:center;gap:8px;padding:6px 16px 6px 8px;border-radius:999px;border:1px solid #c5cdd4;background:#ffffff;color:#1f2933 !important;font-weight:600;box-shadow:0 1px 2px rgba(16,24,40,.08);text-decoration:none !important;transition:background-color .15s,border-color .15s}
.rb-pill:hover{background:#f6f8fa;border-color:#9aa5af}
.rb-pill i{color:#5f8f1a}

/* ═════════════ responsive ═════════════ */
@media (max-width:820px){
  .rb-dock{--speed-presets:none;--joy-size:104px;--dpad-btn:36px}
  .rb-dock-body{grid-template-columns:minmax(0,1fr);gap:12px}
  .rb-dock-right{justify-content:center;gap:12px}
  .rb-stack{flex-direction:row}
  .rb-speed{max-width:none}
}
@media (max-width:480px){
  .rb-btn-sm{flex:1 1 auto;padding:0 8px;font-size:13px}
  .rb-btn-sm span{display:none}            /* icon-only action buttons on phones */
  .rb-btn-sm.rb-red span,.rb-btn-sm.rb-dark span{display:inline}
  .rb-topbar-btns{width:100%}
  .rb-stack .rb-btn{min-width:84px}
}

/* ═════════════ Robot Operations popup (scoped to .rb-pop) ═════════════ */
.rb-pop{--rb-ink:#1f2933;--rb-line:#e3e8eb;--rb-surface-2:#f6f8fa}
.rb-pop .modal-content{background:#fff;border:1px solid var(--rb-line);border-radius:16px;overflow:hidden;box-shadow:0 24px 60px rgba(16,24,40,.28),0 2px 6px rgba(16,24,40,.08)}
.rb-pop .modal-header{background:var(--rb-surface-2);border-bottom:1px solid var(--rb-line);padding:12px 18px;align-items:center}
.rb-pop .modal-title{font-size:1.15rem;font-weight:700;color:var(--rb-ink);line-height:1.2}
.rb-pop .modal-body{padding:14px 18px 16px}
.rb-pop .modal-footer{background:var(--rb-surface-2);border-top:1px solid var(--rb-line);padding:10px 18px}
.rb-pop .gc-sp-text{color:var(--rb-ink)}

/* Connect / Stop: normal buttons in their own row (no longer grey pills laid over the camera) */
.rb-pop-actions{display:flex;flex-wrap:wrap;gap:10px;margin-top:14px;padding-top:12px;border-top:1px solid var(--rb-line)}
.rb-pop-actions > div{flex:1 1 150px;min-width:0}
.rb-pop-actions .rb-btn{width:100% !important}

@media (max-width:576px){
  .rb-pop .modal-header{padding:10px 14px}
  .rb-pop .modal-body{padding:12px 12px 14px}
  .rb-pop .modal-footer{padding:8px 12px}
  .rb-pop .modal-title{font-size:1.05rem}
  .rb-pop-actions{gap:8px}
}

/* ═════════════ connected-time pill (robot card + popup) ═════════════ */
.rb-uptime{display:inline-flex;align-items:center;gap:6px;background:#eef5dc;color:#2f5d1a;border:1px solid #d9e8b5;border-radius:999px;padding:2px 10px;font-size:12.5px;font-weight:600;line-height:1.5;white-space:nowrap;font-variant-numeric:tabular-nums}
.rb-uptime i{font-size:12px;color:#5f8f1a}
.rb-uptime-idle{background:#f6f8fa;color:#5b6770;border-color:#dde3e8}
.rb-uptime-idle i{color:#8dbd2a;font-size:8px}

/* ═════════════ popup buttons: padding / outline no longer depend on a CSS border ═════════════
   (borders were removed in robot.css; the outline is now an inset shadow so size and padding stay identical either way) */
.rb-pop .rb-btn,.rb-pop .rb-pill{box-sizing:border-box !important;border:0 !important;min-height:44px !important;padding:0 18px !important;line-height:1.2 !important;box-shadow:inset 0 0 0 1px #c5cdd4,0 1px 2px rgba(16,24,40,.08) !important;margin:0 !important}
.rb-pop .rb-pill{padding:0 18px 0 8px !important}
.rb-pop .rb-btn.rb-active{box-shadow:inset 0 0 0 1px var(--c),0 0 0 3px var(--c-ring),0 2px 6px rgba(16,24,40,.18) !important}
.rb-pop .rb-btn:hover,.rb-pop .rb-pill:hover{box-shadow:inset 0 0 0 1px #9aa5af,0 2px 6px rgba(16,24,40,.12) !important}
.rb-pop-actions .rb-btn{justify-content:center}
`;
//*** ================= end Joystick / Direction Pad / Speed controller + page control bars ================= ***//

//*** Send frames to robots ***//
export const send_command_message_to_robot = (commandmessage) => {
    try {
        var PlantID = sessionStorage.getItem("user_plantid");
        var sruserID = sessionStorage.getItem("user_id");
        client1.publish(MQTT_Subscribe_Topic, commandmessage)
        console.log(commandmessage)
    }
    catch (e) {
        //2025-06-25 handleMQTTError(PlantID, 0, "RobotOperation.js", "send_command_message_to_robot", "COMMANDPROCESSINGERROR", "COMMANDPROCESSINGERROR:" + e.message + "", "COMMAND PROCESSING ERROR", "01", "www.bhuhit.com", "SE-F-1002");
        //handleTryCatchError(e, "RobotOperation.js", "client1.on(error)")
        console.log("Step-5 (Command Processing) Error: " + e.message + "");
    }
}
// ----------------------------
// Utility: Format HH:MM:SS
// ----------------------------
const formatTime = (totalSeconds) => {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;

    return (
        String(h).padStart(2, "0") + ":" +
        String(m).padStart(2, "0") + ":" +
        String(s).padStart(2, "0")
    );
};

// ----------------------------
// Compute LIVE connected time
// ----------------------------
const pageStartTime = Date.now();

const getLiveSeconds = () => {
    const now = Date.now();
    return Math.floor((now - pageStartTime) / 1000);
};


const getLiveSeconds_old = (robot) => {
    if (robot.broadcastStatus !== "Connected") {
        // Robot is disconnected → return stored DB time
        return "2025-11-21 19:00:00" //robot.robot_connected_status_date_time;
    }

    // Robot is connected → show live timer
    const last = new Date(robot.lastConnectedAt);
    const now = new Date();

    const extra = Math.floor((now - last) / 1000); // seconds since connected

    return robot.robot_connected_time + extra;
};

//*** Start code for multiple robot operation page ***//
export const RobotOperation = ({ robot }) => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [data, setData] = useState([]);
    const [List, setList] = useState([]);
    const [checkedList, setCheckedList] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [masterChecked, setMasterChecked] = useState(false);
    const [itemChecked, setItemChecked] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalRobotId, setModalRobotId] = useState(null);     // which robot's "Robot Operations" popup is open
    const [pageSpeed, setPageSpeed] = useState(128);           // ONE speed for the page bars and the popup
    const [connectedAt, setConnectedAt] = useState({});           // { robotID: ms } time the robot answered the handshake (FID + IP) = connected
    const speedTouchedRef = useRef(0);                            // last time the user moved the Speed slider
    const lastReportedSpdRef = useRef({});                        // last speed each robot reported
    const modalRobotIdRef = useRef(null);                         // always-current popup robot (the MQTT handler must not read a stale value)
    const [showPageDrive, setShowPageDrive] = useState(true);  // show/hide Joystick + DPad + Speed in the top/bottom bars
    const [dockHeight, setDockHeight] = useState(220);               // real height of the sticky dock (measured), used as spacer in the popup
    const [showSelectedOnly, setShowSelectedOnly] = useState(false); // show only the ticked robots (their cameras sit together)
    modalRobotIdRef.current = modalRobotId;
    const lastDriveLoggedRef = useRef({});                      // last "cmd+turn" written to the DB per robot
    const [isConnected, setIsConnected] = useState(false);
    const [isBatteryStatus, setIsBatteryStatus] = useState(false);
    const response = { data: { showSprayerStatus: 0 } }
    const [sprayerStatus, setSprayerStatus] = useState(response.data.showSprayerStatus);
    const [cbStatus, setCBStatus] = useState(75);
    const [mbStatus, setMBStatus] = useState(35);
    const [tlStatus, setTLStatus] = useState(1);
    const [tankWaterLevelStatus, setTankWaterLevelStatus] = useState(100);
    const [angle, setAngle] = useState(30);
    const [latitude, setLatitude] = useState(0);
    const [longitude, setLongitude] = useState(0);
    const [rID, setRID] = useState(5);
    const srPlantID = sessionStorage.getItem("user_plantid");
    const [value, setValue] = useState(false);
    const [robotConnectedTime, setRobotConnectedTime] = useState(0);
    var previousTimeRef = useRef(Date.now());
    const [currentTime, setCurrentTime] = useState(new Date());
    // Selected command state
    const [selectedCmd, setSelectedCmd] = useState("");
    const [robotUptime, setRobotUptime] = useState({});
    const [isCameraOn, setIsCameraOn] = useState(false);
    // Which robot's camera is currently the active one. isCameraOn alone
    // can't answer "camera on for which robot" — there's one shared
    // connection (see CHANNEL_NAME) so only one robot can really be active
    // at a time. This is what each row/modal should check against
    // user.robotID, instead of relying on isCameraOn or the MQTT-derived
    // RobotID variable, so a click on one robot no longer affects the
    // camera icon shown on every other robot's row.
    const [activeCameraRobotId, setActiveCameraRobotId] = useState(null);

    // ******** Start WebRTC KVS***********************

    // videoRef points to the actual <video> tag on the screen, so we can
    // put the video stream into it later
    const videoRef = useRef(null);
    const videoModalRef = useRef(null);
    // pcRef stores our WebRTC connection object (so it survives re-renders)
    const pcRef = useRef(null);

    // signalingClientRef stores our connection to AWS (so it survives re-renders)
    const signalingClientRef = useRef(null);

    // status holds the current state (idle/connecting/live/error/closed)
    // setStatus is the function we call to change it
    const [status, setStatus] = useState(STATUS.IDLE);

    // errorMessage holds any error text to show the user
    const [errorMessage, setErrorMessage] = useState(null);

    // logEntries holds a running history of what happened and when —
    // connects, drops, reconnect attempts, measured downtime — so you can
    // review or export it after a field test instead of only seeing it
    // scroll past in the browser console.
    const [logEntries, setLogEntries] = useState([]);

    // addLogEntry() timestamps a message and appends it to the on-screen
    // log, keeping only the most recent 300 entries so it can't grow
    // forever during a long unattended run.
    const addLogEntry = useCallback((message) => {
        const entry = { time: new Date().toISOString(), message };
        setLogEntries((prev) => {
            const next = [...prev, entry];
            return next.length > 300 ? next.slice(next.length - 300) : next;
        });
    }, []);

    // reconnectTimeoutRef stores the pending setTimeout id for a scheduled
    // reconnect attempt, so we can cancel it if the user stops manually
    // or the component unmounts
    const reconnectTimeoutRef = useRef(null);

    // reconnectAttemptsRef counts consecutive failed reconnect attempts,
    // used to back off (wait longer between tries) and to eventually stop
    const reconnectAttemptsRef = useRef(0);

    // manualStopRef tracks whether the user clicked "Stop" on purpose —
    // if so, we should NOT auto-reconnect when cleanup() runs
    const manualStopRef = useRef(false);

    // startViewingRef always points at the latest startViewing function.
    // scheduleReconnect() below needs to call startViewing, but startViewing
    // is defined further down — this ref sidesteps that ordering problem.
    const startViewingRef = useRef(null);

    // statsIntervalRef holds the stall-watchdog's setInterval id
    const statsIntervalRef = useRef(null);

    // keepaliveIntervalRef holds the signaling-keepalive setInterval id.
    // lastLocalCandidateRef remembers the most recent local ICE candidate
    // we sent, so the keepalive has something real to resend.
    const keepaliveIntervalRef = useRef(null);
    const lastLocalCandidateRef = useRef(null);

    // lastFramesDecodedRef / staleChecksRef track the decoder's frame count
    // between watchdog ticks, so we can tell "no new frames" apart from
    // "just checked, all normal"
    const lastFramesDecodedRef = useRef(null);
    const staleChecksRef = useRef(0);

    // outageStartedAtRef records when the CURRENT outage was first detected
    // (by whichever detector — ICE state, signaling close/error, or the
    // stall watchdog — notices it first). Used purely to measure and log
    // the actual end-to-end "camera was down for Xms" time.
    const outageStartedAtRef = useRef(null);

    // lastFailureReasonRef remembers the most recent disconnect/retry-failure
    // reason, so the quiet "still retrying" heartbeat (see QUIET_RETRY_LOG_EVERY)
    // can still show what's actually going wrong during a long outage.
    const lastFailureReasonRef = useRef(null);

    // attemptIdRef gives every call to startViewing() a unique id. Async
    // code inside that attempt (AWS calls, the signaling 'open'/'sdpAnswer'
    // handlers, onicecandidate) checks its own captured id against this
    // ref before touching shared state or sending anything — if a newer
    // attempt has since started, the stale one becomes a safe no-op
    // instead of racing with it or sending on a closed socket.
    const attemptIdRef = useRef(0);

    // attemptTimeoutRef holds the timer that gives up on a single stuck
    // attempt (see SETUP_TIMEOUT_MS / ICE_TIMEOUT_MS above) and hands off to scheduleReconnect.
    const attemptTimeoutRef = useRef(null);

    // channelCacheRef holds { channelARN, wssEndpoint, httpsEndpoint } once
    // we've successfully resolved them once. Reused on every later
    // reconnect instead of asking AWS again — these don't change for a
    // given channel name. Seeded from sessionStorage so a page refresh
    // doesn't lose it and force a fresh AWS resolve unnecessarily.
    const channelCacheRef = useRef(loadFromSessionStorage(SESSION_STORAGE_CHANNEL_KEY));

    // iceServersCacheRef holds { iceServers, expiresAt } — the last fetched
    // TURN/STUN server list and when its credentials actually expire.
    // Reused as long as it's not close to expiring; refetched otherwise.
    // Also seeded from sessionStorage, but only trusted if it hasn't
    // actually expired since the page was last open — a stale TURN
    // credential from an hour-old tab is worse than no cache at all.
    const iceServersCacheRef = useRef((() => {
        const cached = loadFromSessionStorage(SESSION_STORAGE_ICE_KEY);
        if (cached && typeof cached.expiresAt === 'number' && Date.now() < cached.expiresAt - ICE_SERVERS_REFRESH_MARGIN_MS) {
            return cached;
        }
        if (cached) clearSessionStorage(SESSION_STORAGE_ICE_KEY); // expired — don't leave stale data sitting around
        return null;
    })());

    // cleanup() closes everything down safely — closes the video
    // connection, closes the AWS connection, and clears the video screen
    const cleanup = useCallback((clearVideo = true) => {
        console.log(`[PiViewer] Cleanup Step 1: cleanup() called — closing connections (clearVideo=${clearVideo})`);

        // Cancel any pending auto-reconnect attempt so we don't end up with
        // two connections racing each other
        if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
            reconnectTimeoutRef.current = null;
        }

        // Invalidate any in-flight attempt (AWS calls, signaling handlers)
        // so it becomes a no-op if it eventually resolves after we've
        // already moved on — this is what makes it safe to give up on a
        // stuck attempt without waiting for it to actually finish.
        attemptIdRef.current += 1;

        if (attemptTimeoutRef.current) {
            clearTimeout(attemptTimeoutRef.current);
            attemptTimeoutRef.current = null;
        }

        // Stop the stall watchdog too
        if (statsIntervalRef.current) {
            clearInterval(statsIntervalRef.current);
            statsIntervalRef.current = null;
        }
        lastFramesDecodedRef.current = null;
        staleChecksRef.current = 0;

        // And the signaling keepalive
        if (keepaliveIntervalRef.current) {
            clearInterval(keepaliveIntervalRef.current);
            keepaliveIntervalRef.current = null;
        }

        if (pcRef.current) {
            // Detach our state-change listeners first so closing the old
            // connection can't itself trigger another reconnect
            pcRef.current.oniceconnectionstatechange = null;
            pcRef.current.onconnectionstatechange = null;
            pcRef.current.close(); // close the WebRTC connection
        }
        pcRef.current = null; // forget it, so we don't close it twice

        signalingClientRef.current?.close(); // close the AWS connection if it exists
        signalingClientRef.current = null; // forget it too

        if (clearVideo && (videoRef.current || videoModalRef.current)) {
            videoRef.current.srcObject = null; // clear the video screen
            videoModalRef.current.srcObject = null; // clear the video modal screen
        }
        // When clearVideo is false (an automatic reconnect), we deliberately
        // leave the old srcObject in place. The underlying tracks are already
        // ending because pc.close() ran above, so playback just freezes on
        // the last real frame instead of the screen snapping to blank/black
        // — much less jarring during a reconnect that may only take a couple
        // of seconds. It gets replaced with the new stream in ontrack(), or
        // explicitly cleared by stopViewing()/unmount if we never reconnect.

        console.log('[PiViewer] Cleanup Step 2: cleanup() complete');
    }, []);

    // scheduleReconnect() is called when we detect the live connection has
    // died underneath us (e.g. mobile carrier NAT silently dropped the UDP
    // path around the ~30s mark). Rather than sitting frozen forever, we
    // tear down and rebuild the whole session after a short, growing delay.
    const scheduleReconnect = useCallback((reason) => {
        if (manualStopRef.current) {
            // User pressed Stop on purpose — don't fight them by reconnecting
            return;
        }

        if (reconnectAttemptsRef.current === 0) {
            // This is the first sign of trouble for this outage — start the
            // stopwatch so we can log the real, measured downtime once
            // video comes back.
            outageStartedAtRef.current = performance.now();
        }
        lastFailureReasonRef.current = reason;

        reconnectAttemptsRef.current += 1;
        const attempt = reconnectAttemptsRef.current;

        if (attempt <= RECONNECT_MAX_ATTEMPTS) {
            // Log WHY every one of the first several attempts failed, not just
            // the very first — otherwise a long outage's log is a wall of
            // "Retrying..." lines with no way to tell if it's the same problem
            // repeating or something new each time.
            addLogEntry(`Connection lost (attempt ${attempt}): ${reason}`);
        }

        if (attempt === RECONNECT_MAX_ATTEMPTS + 1) {
            // We've tried the normal number of times without luck. For an
            // unattended robot camera, nobody may be watching to click
            // "Watch Stream" again — so we do NOT give up. We just stop
            // logging every single attempt from here on so a long outage
            // (e.g. waiting for the Pi's own reconnect loop, which can take
            // well over a minute) doesn't flood the log.
            addLogEntry(`Still no response after ${RECONNECT_MAX_ATTEMPTS} attempts (last reason: ${reason}) — camera or robot may be offline. Will keep retrying quietly every ${RECONNECT_MAX_DELAY_MS / 1000}s.`);
        } else if (attempt > RECONNECT_MAX_ATTEMPTS && attempt % QUIET_RETRY_LOG_EVERY === 0) {
            // Periodic "still trying" heartbeat during a long outage, so the
            // log shows we're alive and retrying rather than going silent.
            const downtimeSoFar = outageStartedAtRef.current !== null
                ? Math.round((performance.now() - outageStartedAtRef.current) / 1000)
                : null;
            addLogEntry(`Still retrying (last reason: ${lastFailureReasonRef.current}) — camera has been unreachable for ~${downtimeSoFar}s`);
        }

        // Exponential backoff, capped at RECONNECT_MAX_DELAY_MS: 1s, 2s, 4s, 8s, 10s, 10s...
        // and it stays capped there indefinitely — we never stop retrying on our own.
        const delay = Math.min(RECONNECT_BASE_DELAY_MS * 2 ** (attempt - 1), RECONNECT_MAX_DELAY_MS);
        console.log(`[PiViewer] Reconnect: connection lost (${reason}) — attempt ${attempt} in ${delay}ms`);

        setStatus(STATUS.RECONNECTING);
        cleanup(false); // close the dead connection, but leave the last frame on screen instead of blanking it

        reconnectTimeoutRef.current = setTimeout(() => {
            reconnectTimeoutRef.current = null;
            startViewingRef.current?.(/* isReconnect */ true);
        }, delay);
    }, [cleanup, addLogEntry]);

    // startStallWatchdog() begins polling the peer connection's decoder
    // stats. A frozen feed where the network path looks fine (ICE stays
    // "connected") but no new frames are arriving won't trip the ICE-state
    // listeners at all — this is what actually catches that case.
    const startStallWatchdog = useCallback(() => {
        if (statsIntervalRef.current) return; // already running, don't stack intervals

        lastFramesDecodedRef.current = null;
        staleChecksRef.current = 0;

        statsIntervalRef.current = setInterval(async () => {
            const pc = pcRef.current;
            if (!pc) return;
            try {
                const stats = await pc.getStats();
                let framesDecoded = null;
                stats.forEach((report) => {
                    if (report.type === 'inbound-rtp' && (report.kind === 'video' || report.mediaType === 'video')) {
                        framesDecoded = report.framesDecoded;
                    }
                });
                if (framesDecoded === null || framesDecoded === undefined) return; // stats not ready yet

                if (framesDecoded === lastFramesDecodedRef.current) {
                    staleChecksRef.current += 1;
                    console.log(`[PiViewer] stall watchdog: no new frames decoded (${staleChecksRef.current}/${STALL_MAX_STALE_CHECKS})`);
                    if (staleChecksRef.current >= STALL_MAX_STALE_CHECKS) {
                        console.log('[PiViewer] stall watchdog: video is frozen (ICE still reports connected) — forcing reconnect');
                        scheduleReconnect('video stalled: no new frames decoded');
                    }
                } else {
                    lastFramesDecodedRef.current = framesDecoded;
                    staleChecksRef.current = 0;
                }
            } catch (e) {
                console.log('[PiViewer] stall watchdog: getStats() failed', e);
            }
        }, STALL_CHECK_INTERVAL_MS);
    }, [scheduleReconnect]);

    // startSignalingKeepalive() periodically resends the last local ICE
    // candidate over the signaling WebSocket — see SIGNALING_KEEPALIVE_INTERVAL_MS
    // above for why. This is intentionally NOT tied to attemptId the way most
    // other things in this file are: it's called with an explicit reference to
    // the signaling client and candidate it should use, so it can't accidentally
    // send on a client that's already been superseded.
    const startSignalingKeepalive = useCallback((signalingClient, myAttemptId) => {
        if (keepaliveIntervalRef.current) clearInterval(keepaliveIntervalRef.current);

        keepaliveIntervalRef.current = setInterval(() => {
            if (attemptIdRef.current !== myAttemptId) return; // this attempt is stale — a newer one has taken over
            const candidate = lastLocalCandidateRef.current;
            if (!candidate) return; // nothing to resend yet

            try {
                signalingClient.sendIceCandidate(candidate);
                console.log('[PiViewer] Sent signaling keepalive (resent last ICE candidate)');
            } catch (e) {
                // Not fatal — if the socket's actually dead, the ICE/stall
                // watchdogs will already be moving toward a reconnect anyway.
                console.log('[PiViewer] Signaling keepalive failed to send (socket likely closed)', e);
            }
        }, SIGNALING_KEEPALIVE_INTERVAL_MS);
    }, []);

    // startViewing() is the main function — it does everything needed
    // to connect to the  Pi's camera and start watching
    const startViewing = useCallback(async (isReconnect = false) => {
        console.log(`[PiViewer] Step 1: startViewing() called (isReconnect=${isReconnect})`);

        if (!isReconnect) {
            // This is a fresh, user-initiated start (button click), not an
            // automatic retry — reset the manual-stop flag and the backoff
            // counter so a new session gets the full retry budget
            manualStopRef.current = false;
            reconnectAttemptsRef.current = 0;
            addLogEntry('Watch Stream clicked — connecting');
        } else {
            addLogEntry(`Retrying connection (attempt ${reconnectAttemptsRef.current})`);
        }

        setStatus(isReconnect ? STATUS.RECONNECTING : STATUS.CONNECTING);
        setErrorMessage(null); // clear any old error message

        // Give this specific attempt an id, and start its own timeout.
        // Any async code below checks myAttemptId against attemptIdRef
        // before touching shared refs or sending anything — if a newer
        // attempt has since started (because this one got abandoned via
        // the timeout, or the user stopped/retried), this becomes a
        // harmless no-op instead of corrupting state or sending on a
        // socket that's already closed.
        attemptIdRef.current += 1;
        const myAttemptId = attemptIdRef.current;
        const myClientId = makeClientId(); // fresh identity for this attempt — see makeClientId() above for why

        if (attemptTimeoutRef.current) clearTimeout(attemptTimeoutRef.current);
        attemptTimeoutRef.current = setTimeout(() => {
            if (attemptIdRef.current !== myAttemptId) return; // already superseded
            console.log(`[PiViewer] Attempt ${myAttemptId} timed out after ${SETUP_TIMEOUT_MS}ms during signaling setup (no SDP answer yet) — abandoning it`);
            scheduleReconnect(`signaling setup timed out after ${SETUP_TIMEOUT_MS}ms`);
        }, SETUP_TIMEOUT_MS);

        try {
            let channelARN, wssEndpoint, httpsEndpoint;

            if (channelCacheRef.current) {
                // Already resolved this channel once before — reuse it. The
                // channel ARN and its endpoints don't change for a given
                // channel name, so there's nothing to gain by asking AWS again.
                ({ channelARN, wssEndpoint, httpsEndpoint } = channelCacheRef.current);
                console.log('[PiViewer] Reusing cached channel ARN/endpoints — skipping DescribeSignalingChannel + GetSignalingChannelEndpoint', { channelARN });
            } else {
                // STEP 1: Ask AWS "where is this channel, and how do I connect to it?"
                console.log('[PiViewer] Step 2: Describing signaling channel', { CHANNEL_NAME, REGION });

                // Create a connection to AWS using our region and login details
                const kvClient = new KinesisVideoClient({ region: REGION, credentials: CREDENTIALS });

                // Ask AWS: "give me details about this channel name"
                const { ChannelInfo } = await kvClient.send(
                    new DescribeSignalingChannelCommand({ ChannelName: CHANNEL_NAME })
                );
                // Save the channel's unique ID (like its official address)
                channelARN = ChannelInfo.ChannelARN;
                console.log('[PiViewer] Step 3: got channel ARN', channelARN);

                // If a newer attempt has since started (e.g. this one got
                // abandoned by the attempt timeout while this call was still
                // hanging), stop here rather than acting on stale results.
                if (attemptIdRef.current !== myAttemptId) {
                    console.log(`[PiViewer] Attempt ${myAttemptId} superseded — stopping after DescribeSignalingChannel`);
                    return;
                }

                console.log('[PiViewer] Step 4: Getting signaling channel endpoint (viewer role)');
                // Ask AWS: "give me the web addresses to connect to this channel,
                // as a VIEWER (someone watching, not the camera itself)"
                const { ResourceEndpointList } = await kvClient.send(
                    new GetSignalingChannelEndpointCommand({
                        ChannelARN: channelARN,
                        SingleMasterChannelEndpointConfiguration: {
                            Protocols: ['WSS', 'HTTPS'], // we need both a chat address (WSS) and a normal web address (HTTPS)
                            Role: Role.VIEWER, // tell AWS "I am a viewer, not the camera"
                        },
                    })
                );
                // Turn the list of addresses into an easy-to-use object,
                // like { WSS: "...", HTTPS: "..." }
                const endpoints = Object.fromEntries(
                    ResourceEndpointList.map((e) => [e.Protocol, e.ResourceEndpoint])
                );
                wssEndpoint = endpoints.WSS;
                httpsEndpoint = endpoints.HTTPS;
                console.log('[PiViewer] Step 5: got endpoints', endpoints);

                // Cache it for every future reconnect attempt.
                channelCacheRef.current = { channelARN, wssEndpoint, httpsEndpoint };
                saveToSessionStorage(SESSION_STORAGE_CHANNEL_KEY, channelCacheRef.current);
            }

            if (attemptIdRef.current !== myAttemptId) {
                console.log(`[PiViewer] Attempt ${myAttemptId} superseded — stopping after channel resolution`);
                return;
            }

            // STEP 2: Ask AWS for STUN/TURN servers — these help our video
            // connection work even through tricky routers/firewalls
            let iceServers;
            const nowMs = Date.now();
            const cachedIce = iceServersCacheRef.current;

            if (cachedIce && nowMs < cachedIce.expiresAt - ICE_SERVERS_REFRESH_MARGIN_MS) {
                iceServers = cachedIce.iceServers;
                console.log('[PiViewer] Reusing cached ICE server list — skipping GetIceServerConfig', { msUntilExpiry: cachedIce.expiresAt - nowMs });
            } else {
                console.log('[PiViewer] Step 6: Requesting ICE server config (STUN/TURN)');

                // Create a connection to AWS's "signaling" service
                const signalingChannelClient = new KinesisVideoSignalingClient({
                    region: REGION,
                    credentials: CREDENTIALS,
                    endpoint: httpsEndpoint, // use the web address we got above
                });
                // Ask AWS: "give me a list of helper servers (STUN/TURN) to use"
                const { IceServerList } = await signalingChannelClient.send(
                    new GetIceServerConfigCommand({ ChannelARN: channelARN })
                );
                // Build our final list of helper servers:
                // - one basic STUN server (finds our public internet address)
                // - plus all the TURN servers AWS gave us (relay video if needed)
                let minTtlSeconds = ICE_SERVERS_DEFAULT_TTL_S;
                iceServers = [
                    { urls: `stun:stun.kinesisvideo.${REGION}.amazonaws.com:443` },
                    ...IceServerList.map((s) => {
                        if (typeof s.Ttl === 'number') minTtlSeconds = Math.min(minTtlSeconds, s.Ttl);
                        return {
                            urls: s.Uris,
                            username: s.Username,
                            credential: s.Password,
                        };
                    }),
                ];
                console.log('[PiViewer] Step 7: built ICE server list', { count: iceServers.length, ttlSeconds: minTtlSeconds });

                iceServersCacheRef.current = { iceServers, expiresAt: Date.now() + minTtlSeconds * 1000 };
                saveToSessionStorage(SESSION_STORAGE_ICE_KEY, iceServersCacheRef.current);
            }

            if (attemptIdRef.current !== myAttemptId) {
                console.log(`[PiViewer] Attempt ${myAttemptId} superseded — stopping after GetIceServerConfig`);
                return;
            }

            // STEP 3: Open a live "chat line" (WebSocket) to AWS, as a VIEWER
            console.log('[PiViewer] Step 8: Creating signaling client and WebRTC peer connection');

            // Create the AWS signaling client — this is what talks to AWS
            // in real time to swap connection details with the Pi
            const signalingClient = new SignalingClient({
                channelARN,                 // which channel to join
                channelEndpoint: wssEndpoint, // the chat address to connect to
                clientId: myClientId,        // our unique name (fresh for this attempt)
                role: Role.VIEWER,          // we are the viewer, not the camera
                region: REGION,
                credentials: CREDENTIALS,
            });
            // Save it so we can close it later
            signalingClientRef.current = signalingClient;

            // Create our actual WebRTC connection (this carries the video)
            const pc = new RTCPeerConnection({ iceServers });
            pcRef.current = pc; // save it so we can close it later

            // Tell WebRTC: "I only want to RECEIVE video, I'm not sending any"
            pc.addTransceiver('video', { direction: 'recvonly' });
            console.log('[PiViewer] Step 9: peer connection created, recvonly video transceiver added');

            // Watch the ICE connection state. On mobile data, the carrier's
            // NAT can silently drop the UDP mapping (commonly ~30s in) —
            // WebRTC surfaces that as "disconnected" (path lost, may recover
            // briefly on its own) or "failed" (path is gone for good, e.g.
            // "Consent to send expired" in the logs). We don't wait around;
            // we rebuild the session via scheduleReconnect().
            pc.oniceconnectionstatechange = () => {
                const state = pc.iceConnectionState;
                console.log('[PiViewer] oniceconnectionstatechange:', state);
                if (state === 'failed') {
                    scheduleReconnect(`ice ${state}`);
                } else if (state === 'disconnected') {
                    // "disconnected" can sometimes self-heal within a couple
                    // seconds, but on mobile CGNAT it usually doesn't — give
                    // it a brief moment, then reconnect if still not back.
                    setTimeout(() => {
                        if (pcRef.current === pc && pc.iceConnectionState === 'disconnected') {
                            scheduleReconnect('ice disconnected (did not self-heal)');
                        }
                    }, 2000);
                }
            };

            // connectionState is the broader signal (covers ICE + DTLS) —
            // "failed" here is unambiguous, so reconnect immediately.
            pc.onconnectionstatechange = () => {
                console.log('[PiViewer] onconnectionstatechange:', pc.connectionState);
                if (pc.connectionState === 'failed') {
                    scheduleReconnect(`connection ${pc.connectionState}`);
                } else if (pc.connectionState === 'connected') {
                    // This — not ontrack — is the real signal that ICE actually
                    // finished connecting. ontrack fires as soon as the SDP answer
                    // is negotiated, which can happen well before ICE/DTLS actually
                    // completes, so a timer that only ontrack could cancel would be
                    // left running and fire later against a connection that's
                    // genuinely fine (that was the cause of the ~15s reconnect loop).
                    if (attemptTimeoutRef.current) {
                        clearTimeout(attemptTimeoutRef.current);
                        attemptTimeoutRef.current = null;
                    }
                }
            };

            // This runs automatically when video actually starts arriving
            pc.ontrack = (event) => {
                console.log('[PiViewer] Step 10: ontrack event — video stream received from Pi');
                if (videoRef.current || videoModalRef.current) {
                    // Put the incoming video into our <video> tag on screen
                    videoRef.current.srcObject = event.streams[0];
                    videoModalRef.current.srcObject = event.streams[0];
                }
                setStatus(STATUS.LIVE); // tell the screen "we are live now!"

                // This attempt succeeded — it no longer needs a timeout watching it.
                if (attemptTimeoutRef.current) {
                    clearTimeout(attemptTimeoutRef.current);
                    attemptTimeoutRef.current = null;
                }

                if (outageStartedAtRef.current !== null) {
                    // We were mid-outage — log exactly how long the camera was actually down,
                    // from first detection to first frame back on screen.
                    const downtimeMs = Math.round(performance.now() - outageStartedAtRef.current);
                    console.log(`[PiViewer] Reconnect: camera back after ${downtimeMs}ms downtime (${reconnectAttemptsRef.current} attempt(s))`);
                    addLogEntry(`Camera back — was down for ${(downtimeMs / 1000).toFixed(1)}s (${reconnectAttemptsRef.current} attempt(s))`);
                    outageStartedAtRef.current = null;
                } else {
                    addLogEntry('Camera live');
                }
                reconnectAttemptsRef.current = 0; // fresh video means the reconnect worked — reset backoff
                startStallWatchdog(); // now that frames are flowing, start watching that they keep flowing
                startSignalingKeepalive(signalingClient, myAttemptId); // try to keep the signaling socket from going idle
            };

            // This runs automatically whenever our side finds a new possible
            // network path (candidate) — we must send it to the Pi
            pc.onicecandidate = ({ candidate }) => {
                if (!candidate) return;
                if (attemptIdRef.current !== myAttemptId) return; // this attempt is stale — a newer one has already taken over
                console.log('[PiViewer] Step 11: onicecandidate event — sending local ICE candidate', candidate);
                lastLocalCandidateRef.current = candidate;
                try {
                    // send this network path info to AWS, which forwards it to the Pi
                    signalingClient.sendIceCandidate(candidate);
                } catch (e) {
                    // The signaling socket can close between us finding a candidate and
                    // sending it (e.g. the network just dropped) — this is exactly the
                    // "connection to the signaling service is not open" crash. It's not
                    // fatal: the ICE/stall watchdogs will already be moving us toward a
                    // reconnect, so just log it instead of letting it go unhandled.
                    console.log('[PiViewer] Failed to send ICE candidate (signaling likely closed)', e);
                }
            };

            // This runs automatically once our chat line to AWS is open
            signalingClient.on('open', async () => {
                if (attemptIdRef.current !== myAttemptId) return; // stale attempt — ignore
                console.log('[PiViewer] Step 12: signaling client "open" event — creating and sending SDP offer');
                try {
                    // Create an "offer" — basically saying "here's what I can receive"
                    const offer = await pc.createOffer({ offerToReceiveVideo: true });
                    // Save this offer as our own description
                    await pc.setLocalDescription(offer);

                    if (attemptIdRef.current !== myAttemptId) return; // dropped out while we were awaiting

                    // Send the offer to AWS, which forwards it to the Pi
                    signalingClient.sendSdpOffer(pc.localDescription);
                    console.log('[PiViewer] Step 13: SDP offer sent');
                } catch (e) {
                    // Network can drop between "socket opened" and "offer sent" — that's
                    // this exact crash from the screenshot ("connection to the signaling
                    // service is not open"). Route it through the normal reconnect path
                    // instead of letting it go unhandled.
                    console.log('[PiViewer] Failed to create/send SDP offer', e);
                    addLogEntry(`Error sending offer: ${e.message || 'signaling closed mid-offer'}`);
                    scheduleReconnect('failed to send SDP offer');
                }
            });

            // This runs automatically when the Pi replies with an "answer"
            signalingClient.on('sdpAnswer', async (answer) => {
                if (attemptIdRef.current !== myAttemptId) return; // stale attempt — ignore
                console.log('[PiViewer] Step 14: sdpAnswer event — answer received from Pi', answer);
                try {
                    // Save the Pi's answer as the "other side's" description
                    await pc.setRemoteDescription(answer);
                    console.log('[PiViewer] Step 15: remote description set from SDP answer');

                    // Signaling setup is proven to be working — replace the short
                    // setup-phase timeout with a longer one that covers actual
                    // ICE/TURN connectivity checks, which can legitimately take a
                    // while on mobile (relay allocation, testing candidate pairs).
                    if (attemptTimeoutRef.current) clearTimeout(attemptTimeoutRef.current);
                    attemptTimeoutRef.current = setTimeout(() => {
                        if (attemptIdRef.current !== myAttemptId) return; // already superseded
                        console.log(`[PiViewer] Attempt ${myAttemptId} timed out after ${ICE_TIMEOUT_MS}ms waiting for ICE to connect (SDP answer was received, so signaling is fine — the network path itself isn't completing)`);
                        scheduleReconnect(`ICE negotiation timed out after ${ICE_TIMEOUT_MS}ms`);
                    }, ICE_TIMEOUT_MS);
                } catch (e) {
                    // A duplicate/late answer arriving after we're already
                    // successfully connected is harmless — the connection is
                    // fine, we just got redundant signaling. Don't tear down a
                    // working stream over it. "wrong state: stable" specifically
                    // means an answer was already applied once.
                    const alreadyConnected = pc.signalingState === 'stable' &&
                        (pc.connectionState === 'connected' || pc.iceConnectionState === 'connected' || pc.iceConnectionState === 'completed');
                    if (alreadyConnected) {
                        console.log('[PiViewer] Ignoring redundant/duplicate SDP answer — already connected', e.message);
                    } else {
                        console.log('[PiViewer] Failed to set remote description from SDP answer', e);
                        addLogEntry(`Error applying answer: ${e.message || 'unknown'}`);
                        scheduleReconnect('failed to apply SDP answer');
                    }
                }
            });

            // This runs automatically when the Pi sends us a network path (candidate)
            signalingClient.on('iceCandidate', (candidate) => {
                if (attemptIdRef.current !== myAttemptId) return; // stale attempt — ignore
                console.log('[PiViewer] Step 16: iceCandidate event — candidate received from Pi', candidate);
                try {
                    // Add that network path to our connection
                    pc.addIceCandidate(candidate);
                } catch (e) {
                    console.log('[PiViewer] Failed to add remote ICE candidate', e);
                }
            });

            // This runs automatically if our chat line to AWS closes.
            // AWS can close this for reasons unrelated to the video path
            // (idle timeout on the signaling socket, etc.), so treat it the
            // same as a dropped connection and try to recover automatically
            // rather than just freezing on CLOSED.
            signalingClient.on('close', () => {
                if (attemptIdRef.current !== myAttemptId) return; // stale attempt (likely closed by our own cleanup()) — ignore
                console.log('[PiViewer] Step 17: signaling client "close" event');
                if (!manualStopRef.current) {
                    scheduleReconnect('signaling client closed');
                } else {
                    setStatus(STATUS.CLOSED); // tell the screen "connection closed" (user-initiated)
                }
            });

            // This runs automatically if something goes wrong with signaling
            signalingClient.on('error', (err) => {
                if (attemptIdRef.current !== myAttemptId) return; // stale attempt — ignore
                console.log('[PiViewer] Step 18: signaling client "error" event', err);
                setErrorMessage(err.message || 'Signaling error'); // show the error
                scheduleReconnect(`signaling error: ${err.message || 'unknown'}`);
            });

            // Actually start the connection process now
            console.log('[PiViewer] Step 19: opening signaling client connection...');
            signalingClient.open();
        } catch (err) {
            // If anything above throws an error, we land here
            console.log('[PiViewer] Step 20: error caught in startViewing()', err);
            if (attemptTimeoutRef.current) {
                clearTimeout(attemptTimeoutRef.current);
                attemptTimeoutRef.current = null;
            }
            // Safety net: an actual thrown error (as opposed to a timeout)
            // could mean the cached channel/endpoint info has genuinely gone
            // stale (e.g. the channel was recreated). Drop the cache so the
            // next attempt re-resolves from scratch instead of repeating
            // the same failure indefinitely.
            channelCacheRef.current = null;
            clearSessionStorage(SESSION_STORAGE_CHANNEL_KEY);
            setErrorMessage(err.message || 'Failed to connect to robot camera.'); // show error text
            // Same reasoning as the timeout paths: don't hard-stop and wait for
            // someone to click "Watch Stream" again — keep retrying in the
            // background. scheduleReconnect() itself checks manualStopRef, so a
            // deliberate Stop still won't be fought.
            scheduleReconnect(`error: ${err.message || 'unknown'}`);
        }
    }, [cleanup, scheduleReconnect, startStallWatchdog, startSignalingKeepalive, addLogEntry]); // this function depends on cleanup, scheduleReconnect, startStallWatchdog, startSignalingKeepalive and addLogEntry, so re-make it if any change

    // stopViewing() is called when the user clicks "Stop"
    const stopViewing = useCallback(() => {
        console.log('[PiViewer] stopViewing() called — triggering cleanup');
        addLogEntry('Stopped by user');
        manualStopRef.current = true; // this was on purpose — don't auto-reconnect
        cleanup(); // close everything (also cancels any pending reconnect timer)
        setStatus(STATUS.IDLE); // go back to the starting state
    }, [cleanup, addLogEntry]);

    // Keep startViewingRef pointing at the latest startViewing function.
    // scheduleReconnect() calls through this ref instead of depending on
    // startViewing directly, avoiding a circular useCallback dependency.
    useEffect(() => {
        startViewingRef.current = startViewing;
    }, [startViewing]);

    // When this component disappears from the screen (unmounts), mark it as
    // a manual stop (so no reconnect fires after we're gone) and clean up
    useEffect(() => {
        return () => {
            manualStopRef.current = true;
            cleanup();
        };
    }, [cleanup]);

    // downloadLog() saves the current event log to a .txt file the browser
    // downloads, e.g. for attaching to a bug report or reviewing after an
    // unattended field test.
    const downloadLog = useCallback(() => {
        const text = logEntries.map((e) => `${e.time}  ${e.message}`).join('\n');
        const blob = new Blob([text], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `pi-viewer-log-${new Date().toISOString().replace(/[:.]/g, '-')}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }, [logEntries]);

    // A simple true/false flag: are we currently trying to watch or watching?
    const isWatching = status === STATUS.CONNECTING || status === STATUS.LIVE || status === STATUS.RECONNECTING;

    // ******************* End WebRTC KVS


    const baseBtn = {
        padding: "6px 12px",
        marginRight: "10px",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "0.2s",
        display: "inline-block",
        whiteSpace: "nowrap"
    };

    const hoverSelect = (cmd) => ({
        ...baseBtn,
        backgroundColor: selectedCmd === cmd ? "#2ecc71" : "",
    });


    //*** Send dummy frame to check robot connected or not ***// 
    const checkRobotsConnectivity = () => {
        var PlantID = sessionStorage.getItem("user_plantid");
        //setSelectedList(List.filter((e) => e.selected))
        //let tempList = List;
        //tempList.map((user) => {
        var obj = new Object();
        obj.PID = PlantID;
        obj.FID = 5;
        obj.RCS = "CON";
        var objRTCS = JSON.stringify(obj);
        Client_subscribe_to_mqtt_topic();
        //*** Send MQTT Broadcasting Message to Robot ***//
        client1.publish(MQTT_Subscribe_Topic, objRTCS)
        // });
        //setList(tempList);
        //setSelectedList(List.filter((user) => user.selected));
        //setItemChecked(true);

        // console.log("Step-1 (Broadcasting): Operator have sent Robot ID " + robotID + " to Robot and have completed step 1/6.");
    }
    //*** Create frame for robots broadcast ***//
    const Create_broadcasting_command_message = (btn, _robotID, div) => {
        //*** Send broadcast command to cloud database ***//
        var PlantID = sessionStorage.getItem("user_plantid");
        var sruserID = sessionStorage.getItem("user_id");
        // a connect / disconnect request always ends the current connected-time (a new one starts when the robot answers again)
        setConnectedAt((prev) => { if (!prev[String(_robotID)]) return prev; const n = { ...prev }; delete n[String(_robotID)]; return n; });
        document.getElementById("btnConnect" + _robotID).innerHTML = "Connect";
        document.getElementById("btnConnect_1" + _robotID).innerHTML = "Connect";
        try {
            const bcresponse = AxiosInstance.get("/RobotBroadcast/addbcs?pid=" + PlantID + "&uid=" + sruserID + "&rid=" + _robotID + "&rcs=Disconnected")
            //        .then((res) => {
            //            if (res.status === 200) {
            //                if (res.data === 'Success') console.log("OK: The request was successful, and the server responded with the requested data.")
            //                else if (res.data === 'unSuccess') console.log("The request was not successful, and the server responded with the requested data.")
            //            }
            //            else if (res.status === 201) {
            //                console.log("Created:The request was successful, and a new resource was created.")
            //            }
            //            else if (res.status === 204) {
            //                console.log("No Content: The request was successful, but there is no content to send in the response.")
            //             }

            //        })
            //    .catch(
            //        function (error) {
            //            handleMQTTError(PlantID, _robotID,"RobotOperation.js", "Create_broadcasting_command_message", error.code, error.type, "Error to Broadcasting Robot:"+_robotID+"", "Client Broadcasting Error", "01", "www.bhuhit.com", "SF-F-1002");
            //            if (error.response) {
            //                // The request was made and the server responded with a status code
            //                console.log(error.response.status);
            //                console.log(error.response.data);
            //            } else if (error.request) {
            //                //error.request is populated when the error occurs due to a problem with the request itself, such as:
            //                // 1. Network errors: When the request cannot be sent due to a network issue.
            //                // 2. Timeout errors: When the request takes longer than the specified timeout.
            //                // 3. Cancellation errors: When the request is cancelled using CancelToken.
            //                // The request was made but no response was received
            //                console.log('Request error:', error.request);
            //                console.log('Request URL:', error.request.url);
            //                console.log('Request method:', error.request.method);
            //            } else {
            //                // Something happened in setting up the request that triggered an Error
            //                console.log('Error', error.message);
            //            }
            //       }
            //    )

        }
        catch (error) {
            console.log("Error:" + error)
            //2025-06-25 handleMQTTError(PlantID, _robotID, "RobotOperation.js", "Create_broadcasting_command_message", "ROBOTCONNECTIONERROR", "ROBOTCONNECTIONERROR:Robot " + _robotID + " is not Connecting..", "ROBOT_CONNECTION_ERROR", "01", "www.bhuhit.com", "SF-F-1002");
            //handleTryCatchError(error, "RobotOperation.js", "client1.on(error)")
        }
        var obj = new Object();
        obj.FID = _robotID; //RobotID;
        var Broadcasting_command_message = JSON.stringify(obj);
        Send_broadcasting_command_message_to_robot(Broadcasting_command_message, _robotID);
        setSentCommandButtonActive(btn, _robotID, div, "SendCommand");
        setIsConnected(false);
        startTime = Date.now();
        previousTimeRef.current = Date.now();

        setList(prev =>
            prev.map(r =>
                r.robotID === _robotID
                    ? {
                        ...r,
                        broadcastStatus: "Disconnected",
                        // UI uses stored DB value only
                    }
                    : r
            )
        );

    };

    const hideSprayerStatus = () => {
        setSprayerStatus(prev => prev === 0 ? 1 : 0); // <-- HERE
    }
    let [errorData, setErrorData] = useState({
        plantID: null,
        userID: null,
        errorLevel: "",
        errorMessage: "",
        errorFileName: "",
        errorFunctionName: "",
        errorLineNumber: "",
        errorCode: "",
        errorType: "",
        errorSource: "",
        errorSourceCode: "",
        errorDescriptions: "",
        errorLogTime: "",
        errorMode: 'Insert',
        message: "",
    });


    const Light = ({ active, color }) =>
        <div class="Light" style={{ background: active ? color : "#A0A0A0" }} />
    const PowerLight = ({ state }) =>
        <div class="PowerLight" >
            <Light active={state === 0} color="#F44336" />
            <Light active={state === 1} color="#FFC107" />
            <Light active={state === 2} color="#99cc33" />
        </div>;
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        let tempList = data;
        const filteredData = tempList.filter((event) =>
            Object.values(event).some(
                (value) => typeof value === "string" && value.includes(searchTerm)
            )
        );
        if (event.target.value != null) {
            setList(filteredData);
        }
        if (event.target.value == "") {
            setList(data);
        }
    };
    const filteredData = List.filter((event) =>
        Object.values(event).some(
            (value) => typeof value === "string" && value.includes(searchTerm)
        )
    );
    const handleRowSelected = (rows) => {
        setData(rows.selectedRows);
    };
    const contextActions = (
        <button onClick={() => alert(data.map((r) => r.robotID))}>
            Show Selected Rows
        </button>
    );

    //*** Select/Unselect table rows ***//
    const onMasterCheck = (e) => {
        let tempList = List;
        //*** Check/Uncheck all items
        tempList.map((user) => (user.selected = e.target.checked));
        //*** Update state
        setMasterChecked(e.target.checked);
        setList(tempList);
        setSelectedList(List.filter((e) => e.selected));
    }

    //*** Check table items ***//
    const onItemCheck = (e, item) => {
        let tempList = List;
        tempList.map((user) => {
            if (user.id === item.id) {
                user.selected = e.target.checked;
            }
            return user;
        });

        //*** Control master checkbox state
        const totalItems = List.length;
        const totalCheckedItems = tempList.filter((e) => e.selected).length;

        //*** Update state
        setMasterChecked(totalItems === totalCheckedItems);
        setList(tempList);
        setCheckedList(tempList)
        setSelectedList(List.filter((e) => e.selected));
        setItemChecked(true);
    }

    //*** Check Sprayer checked or not***//
    const onSprayerCheck = (e, item) => {
        let tempList = List;
        tempList.map((user) => {
            if (user.id === item.id) {
                user.sprayerselected = e.target.checked;
            }
            return user;
        });
        //*** Update state
        setList(tempList);
        setSelectedList(List.filter((e) => e.selected));
        setItemChecked(true);
    }

    //*** Check Sprayer checked or not***//
    const onGrassCutterCheck = (e, item) => {
        let tempList = List;
        tempList.map((user) => {
            if (user.id === item.id) {
                user.grasscutterselected = e.target.checked;
            }
            return user;
        });
        //*** Update state
        setList(tempList);
        setSelectedList(List.filter((e) => e.selected));
        setItemChecked(true);
    }

    //*** Check Sprayer checked or not***//
    const onSowingCheck = (e, item) => {
        let tempList = List;
        tempList.map((user) => {
            if (user.id === item.id) {
                user.sowingselected = e.target.checked;
            }
            return user;
        });
        //*** Update state
        setList(tempList);
        setSelectedList(List.filter((e) => e.selected));
        setItemChecked(true);
    }

    //*** Send broadcast frames to selected robots ***//
    const check_selected_robots_connected_status = () => {
        //** Subscribe to MQTT topic **//
        Client_subscribe_to_mqtt_topic();
        //*** Get selected list in array ***//
        setSelectedList(List.filter((e) => e.selected))
        let tempList = selectedList;
        tempList.map((user) => {
            //** Add and clear interval ***//
            const interval = setInterval(() => { }, 400);
            clearInterval(interval);
            Create_broadcasting_command_message("btnAllConnect" + user.robotID, user.robotID, "divAllConnect" + user.robotID);
        });
    }
    //** Received frames from robots to mqtt and from mqtt to UI **//
    client1.on('message', function (topic, message) {
        var plantID = sessionStorage.getItem("user_plantid");
        var userID = sessionStorage.getItem("user_id");
        ////*** message is Buffer ***////
        if (message != null || message !== "") {
            try {
                var obj = JSON.parse(message);
                if (topic === MQTT_Receiver_Topic) {
                    // Receive error frames from robots
                    if (obj.PID != null && obj.ELT != null && obj.EM != null) {
                        //20250923 handleMQTTError("" + obj.PID + "", "" + obj.FID + "", "" + obj.FN + "", "" + obj.EFN + "", "" + obj.EC + "", "" + obj.EM + "", "" + obj.ET + "", "" + obj.EL + "", "" + obj.ES + "", "" + obj.ESC + "");
                    }
                    //*** Add robot connected status (status from robots to Bhuhit UI) in cloud database ***//
                    if (obj.FID != null && obj.IP != null) {
                        IPAddress = obj.IP;
                        RobotID = obj.FID;
                        // alert(IPAddress);
                        //sessionStorage.removeItem("IPAddress");
                        sessionStorage.setItem("IPAddress", IPAddress);
                        // connected-time starts when the robot answers with FID + IP (only the first answer counts)
                        setConnectedAt((prev) => (prev[String(obj.FID)] ? prev : { ...prev, [String(obj.FID)]: Date.now() }));
                        //alert(IPAddress);
                        //obj.ipAddress = IPAddress;
                        document.getElementById("btnConnect" + obj.FID).innerHTML = "<i class='fa fa - toggle - on' style={{color:'#FB4F14'}}></i>&nbsp;Disconnect";
                        document.getElementById("btnConnect_1" + obj.FID).innerHTML = "Disconnect";
                        try {
                            let addRobotConnectedStatus = AxiosInstance.get("/RobotBroadcast/addbcs?pid=" + plantID + "&uid=" + userID + "&rid=" + obj.FID + "&rcs=Connected")
                                .then(() => {
                                    console.log('Updated Robot Connected Status successfully');
                                })
                                .catch(error => {
                                    console.log('Failed to connected status error:', error);
                                    //20250923 handleAxiosError(error, "RobotOperation.js", "client1.on(message)");
                                });
                            setIsConnected(true);
                        }
                        catch (error) {
                            console.log(error.message)
                            //handleTryCatchError(error, "RobotOperation.js", "client1.on(message)");
                        }
                    }
                    //*** Check received frames ***//
                    if (obj.FID != null && obj.Cmd != null) {
                        if (obj.TL != null) setTankWaterLevelStatus(obj.TL)
                        //document.getElementById("CB1" + obj.FID);
                        //alert(topic + "," + message);
                        //*** Step-2 and Step-3 have executed. Operator have connected with Robots***//
                        /*** Step-3 (Connectivity to Robot): You have connected to Robot and have completed step 3 /6. ***/
                        console.log("Step-2 (Broadcasting): Operator have received Robot ID '" + obj.FID + "' from Robot and have completed step 2/6.");// message.payloading
                        console.log("Step-3 (Connectivity to Robot): You are connected to Robot ID '" + obj.FID + "'  and have completed step 3 /6.");
                        if (obj.Cmd != null) Current_command_status = obj.Cmd;
                        if (obj.Spd != null) Current_motor_speed_status = obj.Spd;
                        if (obj.Turn != null) Current_turn_status = obj.Turn;
                        if (obj.GC != null) Current_grass_cutter_status = obj.GC;
                        if (obj.SP != null) Current_sprayer_status = obj.SP;
                        if (obj.SO != null) Current_sowing_status = obj.SP;
                        if (obj.CB != null) Current_controller_battery_status = obj.CB;
                        if (obj.MB != null) Current_controller_battery_status = obj.MB;

                        //**** Add command status (status from robots) to cloud database ****/
                        if (obj.FID != null && obj.Cmd != null) {
                            try {
                                let addCommandStatus = AxiosInstance.get("/PlantRobotOperation/addcmdstatus?pid=" + plantID + "&uid=" + userID + "&rid=" + obj.FID + "&cmd=" + Current_command_status + "&tun=" + Current_turn_status + "&spd=" + Current_motor_speed_status + "&gc=" + Current_grass_cutter_status + "&sp=" + Current_sprayer_status + "&so=" + Current_sowing_status + "&lat=0&lon=0&cb=" + obj.CB + "&mb=" + obj.MB + "&tl=" + obj.TL + "&cid=1")
                                    .then(() => {
                                        console.log('Update command status successfully');
                                    })
                                    .catch(error => {
                                        console.log('Failed to command status error:', error);
                                        //20250923handleAxiosError(error, "RobotOperation.js", "client1.on(message)");
                                    });
                            }
                            catch (error) {
                                console.log(error.message)
                                //handleTryCatchError(error, "RobotOperation.js", "client1.on(message)");
                            }
                            if (obj.Cmd === "F" && obj.Turn === "D") setReceivedCommandButtonActive("btnStart_1" + obj.FID, "divStart_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Cmd === "B" && obj.Turn === "D") setReceivedCommandButtonActive("btnReturn_1" + obj.FID, "divReturn_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            // else if (obj.Cmd === "S" && obj.Turn === "D") setReceivedCommandButtonActive("btnRobotStop_1" + obj.FID, "divRobotStop_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Turn === "D") setReceivedCommandButtonActive("btnTurnStop_1" + obj.FID, "divTurnStop_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Turn === "R" && obj.Cmd === "S") setReceivedCommandButtonActive("btnRight_1" + obj.FID, "divRight_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Turn === "L" && obj.Cmd === "S") setReceivedCommandButtonActive("btnLeft_1" + obj.FID, "divLeft_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Cmd === "F" && obj.Turn === "R") setReceivedCommandButtonActive("btnForwardRight_1" + obj.FID, "divForwardRight_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Cmd === "F" && obj.Turn === "L") setReceivedCommandButtonActive("btnForwardLeft_1" + obj.FID, "divForwardLeft_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Cmd === "B" && obj.Turn === "R") setReceivedCommandButtonActive("btnBackwardRight_1" + obj.FID, "divBackwardRight_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Cmd === "B" && obj.Turn === "L") setReceivedCommandButtonActive("btnBackwardLeft_1" + obj.FID, "divBackwardLeft_1" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Cmd === "F" && obj.Turn === "D") setReceivedCommandButtonActive("btnStart" + obj.FID, "divStart" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Cmd === "B" && obj.Turn === "D") setReceivedCommandButtonActive("btnReturn" + obj.FID, "divReturn" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Turn === "D") setReceivedCommandButtonActive("btnTurnStop" + obj.FID, "divTurnStop" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Turn === "R" && obj.Cmd === "S") setReceivedCommandButtonActive("btnRight" + obj.FID, "divRight" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                            else if (obj.Turn === "L" && obj.Cmd === "S") setReceivedCommandButtonActive("btnLeft" + obj.FID, "divLeft" + obj.FID, "#fff", "#A0A0A0", "#99cc33")
                        }
                        if (obj.FID != null && obj.OPN != null) {
                            try {
                                let addOparationStatus = AxiosInstance.get("/PlantRobotOperation/addcmdstatus?pid=" + plantID + "&uid=" + userID + "&rid=" + obj.FID + "&cmd=OFF&tun=D&spd=0&gc=0&sp=0&lat=0&lon=0&cb=0&mb=0&cid=1")
                                    //Create_broadcasting_command_message(obj.FID);
                                    .then(() => {
                                        console.log('Update operation status successfully');
                                    })
                                    .catch(error => {
                                        console.log('Failed to operation status error:', error);
                                        //20250923 handleAxiosError(error, "RobotOperation.js", "client1.on(message)");
                                    });
                            }
                            catch (error) {
                                console.log(error.message)
                                //handleTryCatchError(error, "RobotOperation.js", "client1.on(message)");
                            }
                        }
                    }
                    //*** Update current lat and lon status from robots to cloud database ****/
                    if (obj.FID != null && obj.lat != null && obj.lon != null) {
                        try {
                            //angle =obj.ang;
                            setAngle(obj.ang);
                            setLatitude(obj.lat);
                            setLongitude(obj.lon);
                            setRID(obj.FID);
                            //let addLatLonStatus = AxiosInstance.get("/robot-location?pid=" + plantID + "&uid=" + userID + "&rid=" + obj.FID + "&lat=" + obj.lat + "&lon=" + obj.lon + "&det=" + obj.Det + "&ang=" + obj.ang + "")
                            //.then(() => {
                            //    console.log('Update lat and lon status successfully');
                            //})
                            //.catch(error => {
                            //    console.log('Failed to lat and lon status error:', error);
                            //    //20250923handleAxiosError(error, "RobotOperation.js", "client1.on(message)");
                            //});
                        }
                        catch (error) {
                            console.log(error.message)
                            //handleTryCatchError(error, "RobotOperation.js", "client1.on(message)");
                        }
                    }
                    //*** Update current CB and MB status from robots to cloud database ****/
                    if (obj.FID != null && (obj.CB !== 0 || obj.MB !== 0)) {
                        setIsBatteryStatus(true);
                        if (obj.CB <= 20 || obj.MB <= 20) {
                            //send_command_to_selected_robots("S", "D", "btnRobotStop_1", obj.FID);
                            //send_command_to_selected_robots("RTCS", "D", "btnRobotStop_1", obj.FID);
                        }
                    }
                    // IPAddress = sessionStorage.getItem("IPAddress") + "front";
                    IPAddress = sessionStorage.getItem("IPAddress");
                    // Refresh CB, MB & TL 
                    let tempList = List;
                    tempList.map((user) => {
                        if (user.robotID === obj.FID) {
                            user.towerlampstatus = 1;

                            if (obj.FID != null && sessionStorage.getItem("IPAddress") != null) IPAddress = sessionStorage.getItem("IPAddress") + "front";
                            if (obj.FID != null && obj.Cmd != null) {
                                if (obj.FID != null && (obj.Cmd === "F" || obj.Cmd === "B" || obj.Cmd === "FR" || obj.Cmd === "FL"
                                    || obj.Cmd === "BR" || obj.Turn === "L" || obj.Turn === "R")) {
                                    user.towerlampstatus = 2;
                                }
                                user.controllerBatteryStatus = obj.CB;
                                user.motorBatteryStatus = obj.MB;
                                user.sprayerselected = obj.SP;
                                user.grasscutterselected = obj.GC;
                                user.sowingselected = obj.SO;
                                user.waterTankLevelStatus = obj.TL
                                // Speed slider follows the speed the robot reports while it moves (Spd > 0).
                                // It follows the popup robot, otherwise any ticked robot; never within 1.5 s of the user's own change.
                                const rSpd = parseInt(obj.Spd, 10);
                                if (Number.isFinite(rSpd)) {
                                    if (rSpd <= 0) lastReportedSpdRef.current[String(obj.FID)] = 0;
                                    else if (lastReportedSpdRef.current[String(obj.FID)] !== rSpd) {
                                        lastReportedSpdRef.current[String(obj.FID)] = rSpd;
                                        const isTarget = modalRobotIdRef.current !== null
                                            ? String(modalRobotIdRef.current) === String(obj.FID)
                                            : !!user.selected;
                                        if (isTarget && Date.now() - speedTouchedRef.current > 1500) setPageSpeed(Math.min(255, rSpd));
                                    }
                                }
                                //user.broadcastStatus = "Connected";
                                //tankWaterLevelStatus = tankWaterLevelStatus;
                                if (obj.Cmd === "B" && (obj.Turn === "D" || obj.Turn === "R" || obj.Turn === "L" || obj.Turn === "S")) {
                                    //IPAddress = sessionStorage.getItem("IPAddress") + "back";
                                    IPAddress = sessionStorage.getItem("IPAddress");
                                }
                                if (obj.Cmd === "F" && (obj.Turn === "D" || obj.Turn === "R" || obj.Turn === "L" || obj.Turn === "S")) {
                                    // IPAddress = sessionStorage.getItem("IPAddress") + "front";
                                    IPAddress = sessionStorage.getItem("IPAddress");
                                }
                            }
                            if (obj.FID != null && obj.OPN != null) user.towerlampstatus = 1;
                            if (obj.FID != null && obj.ELT != null && obj.EM != null) user.towerlampstatus = 0;

                        }
                        return user;
                    }); //alert(IPAddress);
                    if (obj.FID != null && (obj.IPAddress != null || obj.Cmd != null || obj.OPN != null || obj.ELT != null)) {
                        setList(tempList);
                        setSelectedList(List.filter((user) => user.selected));
                        setItemChecked(true);
                    }
                    //setList(prev =>
                    //    prev.map(r =>
                    //        r.robotID === obj.FID
                    //            ? {
                    //                ...r,
                    //                broadcastStatus: "Connected",
                    //                lastConnectedAt: new Date().toISOString()
                    //            }
                    //            : r
                    //    )
                    //);

                    //setSelectedList(List.filter((user) => user.selected));
                }
            }
            catch (err) {
                console.log("Invalid frame format");
            }
        }

    });
    //** Set active command buttons for received commands
    const setReceivedCommandButtonActive = (btnactive, divactive, bgcolor, color, bordercolor) => {
        try {
            //White transparency(rgba(255, 255, 255, 0.55))
            //Black transparency(rgba(0, 0, 0, 0.55))0.45, 0.35, 0.25, 0.15
            //lime rgba(173, 255, 47, 0.25)
            document.getElementById(divactive).style.backgroundColor = "rgba(173, 255, 47, 0.15)";// "#f6fbb3";
            document.getElementById(divactive).style.borderColor = "#9cc33";
            document.getElementById(divactive).style.borderStyle = "solid";
            document.getElementById(divactive).style.borderWidth = "2px";
            document.getElementById(btnactive).style.backgroundColor = "rgba(173, 255, 47, 0.15)"; // "#fff39a"
            document.getElementById(btnactive).style.color = "#fff";
            // document.getElementById(divactive).style.color = "#000";
            //document.getElementById(divactive).style.opacity = "0.65";
        }
        catch (e) {
            console.log("error");
        }
    }
    //*** Get previous seleted rows
    const get_selected_list_items = () => {
        let tempList = List;
        let tempSelectedList = selectedList;
        tempList.map((user1) => {
            tempSelectedList.map((user) => {
                if (user.selected) {
                    user.selected = true;
                }
                // alert(user.robotID)
                return user;
            });
            return user1;
        })
        setData(tempList);
        setList(tempList);
        setItemChecked(true);
    }
    //*** Event to get selected rows(Optional)
    const show_camera = (command, turn) => {
        SubscribtionStatus = Client_subscribe_to_mqtt_topic()
        if (SubscribtionStatus === true) {
            setSelectedList(List.filter((e) => e.selected))
            let tempList = selectedList;
            tempList.map((user) => {
                const interval = setInterval(() => { }, 2000);
                clearInterval(interval);
            }
            );
        }
    }
    const setSentCommandButtonActive = (btnactive, robotID, divactive, mode) => {
        //alert(mode);
        if (btnactive && robotID) {
            //Set div border and background color for default commands 
            setControllerColor("btnStart_1" + robotID, "divStart_1" + robotID, "#fff", "rgba(0, 0, 0, 0.45)", "#ffff00")
            setControllerColor("btnReturn_1" + robotID, "divReturn_1" + robotID, "#fff", "rgba(0, 0, 0, 0.45)", "#ffff00");
            setControllerColor("btnTurnStop_1" + robotID, "divTurnStop_1" + robotID, "#fff", "#rgba(0, 0, 0, 0.45)", "#ffff00");
            setControllerColor("btnForwardRight_1" + robotID, "divForwardRight_1" + robotID, "#fff", "rgba(0, 0, 0, 0.45)", "#ffff00");
            setControllerColor("btnForwardLeft_1" + robotID, "divForwardLeft_1" + robotID, "#fff", "rgba(0, 0, 0, 0.45)", "#ffff00");
            setControllerColor("btnBackwardLeft_1" + robotID, "divBackwardLeft_1" + robotID, "#fff", "rgba(0, 0, 0, 0.45)", "#ffff00");
            setControllerColor("btnBackwardRight_1" + robotID, "divBackwardRight_1" + robotID, "#fff", "rgba(0, 0, 0, 0.45)", "#ffff00");
            setControllerColor("btnRight_1" + robotID, "divRight_1" + robotID, "#fff", "rgba(0, 0, 0, 0.45)", "#ffff00");
            setControllerColor("btnLeft_1" + robotID, "divLeft_1" + robotID, "#fff", "rgba(0, 0, 0, 0.45)", "#ffff00");
            //setControllerColor("btnConnect" + robotID, "divConnect" + robotID, "#fff", "#000000", "#ffff00");
            setControllerColor("btnConnect_1" + robotID, "divConnect_1" + robotID, "#fff", "#63666A");
            // setControllerColor("btnRobotStop" + robotID, "divRobotStop" + robotID, "#fff", "#000000", "#ffff00");
            setControllerColor("btnRobotStop_1" + robotID, "divRobotStop_1" + robotID, "#fff", "#63666A", "#ffff00");
            //setControllerColor("btnGetMore" + robotID, "divGetMore" + robotID, "#fff", "#000000", "#ffff00");


            //setControllerColor("btnStart" + 0, "divStart" + 0, "#fff", "#000", "#ffff00")
            //setControllerColor("btnReturn" + 0, "divReturn" + 0, "#fff", "#000", "#ffff00");
            //setControllerColor("btnTurnStop" + 0, "divTurnStop" + 0, "#fff", "#000000", "#ffff00");
            //setControllerColor("btnForwardRight" + 0, "divForwardRight" + 0, "#fff", "#000000", "#ffff00");
            //setControllerColor("btnForwardLeft" + 0, "divForwardLeft" + 0, "#fff", "#000000", "#ffff00");
            //setControllerColor("btnBackwardLeft" + 0, "divBackwardLeft" + 0, "#fff", "#000000", "#ffff00");
            //setControllerColor("btnBackwardRight" + 0, "divBackwardRight" + 0, "#fff", "#000000", "#ffff00");
            //setControllerColor("btnRight" + 0, "divRight" + 0, "#fff", "#000000", "#ffff00");
            //setControllerColor("btnLeft" + 0, "divLeft" + 0, "#fff", "#000000", "#ffff00");

            // Set div border and background color for sending commands
            //if (btnactive === "btnStart_1" + robotID) setControllerColor("btnStart_1" + robotID, "divStart_1" + robotID, "#fff", "#A0A0A0", "#ffff00");
            //if (btnactive === "btnReturn_1" + robotID) setControllerColor("btnReturn_1" + robotID, "divReturn_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnTurnStop_1" + robotID) setControllerColor("btnTurnStop_1" + robotID, "divTurnStop_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnRight_1" + robotID) setControllerColor("btnRight_1" + robotID, "divRight_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnLeft_1" + robotID) setControllerColor("btnLeft_1" + robotID, "divLeft_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnForwardRight_1" + robotID) setControllerColor("btnForwardRight_1" + robotID, "divForwardRight_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnForwardLeft_1" + robotID) setControllerColor("btnForwardLeft_1" + robotID, "divReturn_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnBackwardRight_1" + robotID) setControllerColor("btnBackwardRight_1" + robotID, "divBackwardRight_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnBackwardLeft_1" + robotID) setControllerColor("btnBackwardLeft_1" + robotID, "divBackwardLeft_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnConnect" + robotID) setControllerColor("btnConnect" + robotID, "divConnect" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnConnect_1" + robotID) setControllerColor("btnConnect_1" + robotID, "divConnect_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnRobotStop" + robotID) setControllerColor("btnRobotStop" + robotID, "divRobotStop" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnRobotStop_1" + robotID) setControllerColor("btnRobotStop_1" + robotID, "divRobotStop_1" + robotID, "#fff", "#000000", "#ffff00");
            //if (btnactive === "btnGetMore" + robotID) setControllerColor("btnGetMore" + robotID, "divGetMore" + robotID, "#fff", "#000000", "#ffff00");


            // Set div border and for sending and receiving commands 
            if (divactive === "divReturn" + robotID || divactive === "divStart" + robotID || divactive === "divGetMore" + robotID || divactive === "divForwardRight_1" + robotID || divactive === "divForwardLeft_1" + robotID || divactive === "divBackwardRight_1" + robotID || divactive === "divBackwardLeft_1" + robotID) {
                document.getElementById(divactive).style.borderColor = "#fff";
                document.getElementById(divactive).style.borderStyle = "solid";
                document.getElementById(divactive).style.borderWidth = "2px";
                document.getElementById(divactive).style.borderRadius = "8px"
                document.getElementById(divactive).style.backgroundColor = "rgba(255, 135, 0, 0.15)";
                document.getElementById(btnactive).style.backgroundColor = "rgba(255, 135, 0, 0.15)";
                document.getElementById(btnactive).style.color = "#fff";
            }
            if (divactive === "divStart_1" + robotID || divactive === "divReturn_1" + robotID || divactive === "divTurnStop_1" + robotID || divactive === "divRight_1" + robotID || divactive === "divLeft_1" + robotID || divactive === "divConnect" + robotID || divactive === "divConnect_1" + robotID || divactive === "divRobotStop" + robotID || divactive === "divRobotStop_1" + robotID) {
                document.getElementById(divactive).style.borderColor = "#f8f8f8";
                document.getElementById(divactive).style.borderStyle = "solid";
                document.getElementById(divactive).style.borderWidth = "2px";
                document.getElementById(divactive).style.borderRadius = "8px"
                document.getElementById(divactive).style.backgroundColor = "rgba(255, 135, 0, 0.15)"//"#f6fbb3"// "#f5f5dc";
                document.getElementById(btnactive).style.backgroundColor = "rgba(255, 135, 0, 0.15)" //"#f6fbb3"// "#f5f5dc";
                document.getElementById(btnactive).style.color = "#fff";
            }
            if (divactive === "divConnect_1" + robotID || divactive === "divRobotStop_1" + robotID) {
                document.getElementById(divactive).style.borderColor = "#f8f8f8";
                document.getElementById(divactive).style.borderStyle = "solid";
                document.getElementById(divactive).style.borderWidth = "2px";
                document.getElementById(divactive).style.borderRadius = "8px"
                document.getElementById(divactive).style.backgroundColor = "#f6fbb3"//"#f6fbb3"// "#f5f5dc";
                document.getElementById(btnactive).style.backgroundColor = "#f6fbb3" //"#f6fbb3"// "#f5f5dc";
                document.getElementById(btnactive).style.color = "#000";
            }
        }
        if (mode === "SendCommand") {
        }
    }
    const setControllerColor = (ctrl, divctrl, color, bgcolor, brcolor) => {
        document.getElementById(ctrl).style.color = color;
        document.getElementById(ctrl).style.backgroundColor = bgcolor; //"#707070";
        document.getElementById(divctrl).style.backgroundColor = bgcolor; //"#707070";
        document.getElementById(divctrl).style.bordercolor = "#ffff00";
        document.getElementById(divctrl).style.borderStyle = "none";
        document.getElementById(divctrl).style.borderWidth = "2px";
        // document.getElementById(divctrl).style.opacity = "0.8";
    }
    //*** Event to get selected rows(Optional)
    const send_command_to_selected_robots = (command, turn, btn, robotid, div, event) => {
        //event.preventDefault();
        var PlantID = sessionStorage.getItem("user_plantid");
        const sruserID = sessionStorage.getItem("user_id");
        //*** Add commands F ,B and S in session variable***// 
        if (command === "F" || command === "B" || command === "S") {
            sessionStorage.removeItem("Command");
            sessionStorage.setItem("Command", command);
        }
        //*** Create previous command and When command = "None" then command="S" ***//
        if (turn === "L" || turn === "R" || turn === "D") {
            if (command === "None" && sessionStorage.getItem("Command") === null) command = "S";
            if (command === "None" && (sessionStorage.getItem("Command") === "F" || sessionStorage.getItem("Command") == "B" || sessionStorage.getItem("Command") == "S")) command = sessionStorage.getItem("Command");
            // alert(command, turn + " from L and R "  );
        }
        //*** Subscribe to MQTT topic ***//
        SubscribtionStatus = Client_subscribe_to_mqtt_topic()
        //*** IF We subscribed to topic then we will send frame to robots ***//
        if (SubscribtionStatus === true) {
            //*** Get Selected List in array ***//
            setSelectedList(List.filter((e) => e.selected))
            let tempList = selectedList;
            tempList.map((user) => {
                //*** Set varibles to null
                Current_command_status = null;
                Current_motor_speed_status = null;
                Current_turn_status = null;
                Current_grass_cutter_status = null;
                Current_sprayer_status = null;
                Current_sowing_status = null;
                //*** Add interval of 5 seconds to send frame for multiple robots and we will clear Interval ***//
                const interval = setInterval(() => { }, 5000);
                clearInterval(interval);
                let grassCutterToggle = document.getElementById(user.robotID + "GCInputToggle");
                let grassCutterToggle1 = document.getElementById(user.robotID + "GC1InputToggle");
                let sprayerToggle = document.getElementById(user.robotID + "SPInputToggle");
                let sprayerToggle1 = document.getElementById(user.robotID + "SP1InputToggle");
                let sowingToggle = document.getElementById(user.robotID + "SOInputToggle");
                let sowingToggle1 = document.getElementById(user.robotID + "SO1InputToggle");
                //let grassCutterOn = document.getElementById(user.robotID + "-GCOn");
                //let grassCutterOff = document.getElementById(user.robotID + "-GCOff");
                //let grassCutterOn1 = document.getElementById(user.robotID + "-GCOn1");
                //let grassCutterOff1 = document.getElementById(user.robotID + "-GCOff1");
                //if (grassCutterOn.checked || grassCutterOn1.checked) {
                //    Current_grass_cutter_status = 1;
                //}
                //else if (grassCutterOff.checked || grassCutterOff1.checked) {
                //    Current_grass_cutter_status = 0;
                //}

                //if (isModalOpen) {
                //    if (grassCutterOn1.checked) {
                //        grassCutterOn.checked = true;
                //        grassCutterOn.value = 1;
                //        Current_grass_cutter_status = 1;
                //    }
                //}
                //if (!isModalOpen) {
                //    if (grassCutterOn.checked) {
                //        grassCutterOn1.checked = true;
                //        grassCutterOn1.value = 1;
                //        Current_grass_cutter_status = 1;
                //    }
                //}
                //if (isModalOpen) {
                //    if (grassCutterOff1.checked) {
                //        grassCutterOff.value = 1;
                //        grassCutterOff.checked = true;
                //        Current_grass_cutter_status = 0;
                //    }
                //}
                //if (!isModalOpen) {
                //    if (grassCutterOff.checked) {
                //        grassCutterOff1.value = 1;
                //        grassCutterOff1.checked = true;
                //        Current_grass_cutter_status = 0;
                //    }
                //}
                //let sprayerOn = document.getElementById(user.robotID + "-SPOn");
                //let sprayerOff = document.getElementById(user.robotID + "-SPOff");
                //let sprayerOn1 = document.getElementById(user.robotID + "-SPOn1");
                //let sprayerOff1 = document.getElementById(user.robotID + "-SPOff1");

                //if (isModalOpen) {
                //    if (sprayerOn1.checked) {
                //        sprayerOn.checked = true;
                //        sprayerOn.value = 1;
                //        Current_sprayer_status = 1;
                //    }
                //}
                //if (!isModalOpen) {
                //    if (sprayerOn.checked) {
                //        sprayerOn1.checked = true;
                //        sprayerOn1.value = 1;
                //        Current_sprayer_status = 1;
                //    }
                //}
                //if (isModalOpen) {
                //    if (sprayerOff1.checked) {
                //        sprayerOff.value = 1;
                //        sprayerOff.checked = true;
                //        Current_sprayer_status = 0;
                //    }
                //}
                //if (!isModalOpen) {
                //    if (sprayerOff.checked) {
                //        sprayerOff1.value = 1;
                //        sprayerOff1.checked = true;
                //        Current_sprayer_status = 0;
                //    }
                //}
                if (grassCutterToggle.checked || grassCutterToggle1.checked) {
                    Current_grass_cutter_status = 1;
                }
                else if (!grassCutterToggle.checked || !grassCutterToggle1.checked) {
                    Current_grass_cutter_status = 0;
                }
                if (sprayerToggle.checked || sprayerToggle1.checked) {
                    Current_sprayer_status = 1;
                }
                else if (!sprayerToggle.checked || !sprayerToggle1.checked) {
                    Current_sprayer_status = 0;
                }
                if (sowingToggle.checked || sowingToggle1.checked) {
                    Current_sowing_status = 1;
                }
                else if (!sowingToggle.checked || !sowingToggle1.checked) {
                    Current_sowing_status = 0;
                }
                Current_command_status = command;
                Current_turn_status = turn;
                if (command === "S" || command === "OFF" || command === "RTP" || command === "RTCS") { // when Command Stop then grass cutter and spraying status =0;
                    Current_grass_cutter_status = 0;
                    Current_sprayer_status = 0;
                    Current_sowing_status = 0;
                    sowingToggle.checked = 0;
                    sowingToggle1.checked = 0;
                    sowingToggle.value = 0;
                    sowingToggle1.value = 0;
                }
                if (Current_turn_status === null || Current_turn_status === '') Current_turn_status = 'D';
                if (Current_motor_speed_status === null || Current_motor_speed_status === '') Current_motor_speed_status = 255;
                if (Current_grass_cutter_status === null || Current_grass_cutter_status === '') Current_grass_cutter_status = 0;
                if (Current_sprayer_status === null || Current_sprayer_status === '') Current_sprayer_status = 0;
                if (Current_sowing_status === null || Current_sowing_status === '') Current_sowing_status = 0;
                //*** Send command to cloud database ***//
                try {
                    const addCommandStatus = AxiosInstance.get("/PlantRobotOperation/addcmd?pid=" + user.plantID + "&uid=" + sruserID + "&rid=" + user.robotID + "&cmd=" + Current_command_status + "&tun=" + Current_turn_status + "&spd=" + Current_motor_speed_status + "&gc=" + Current_grass_cutter_status + "&sp=" + Current_sprayer_status + " &so=" + Current_sowing_status + "&cb=0&mb=0&tl=0&cid=1")
                        .then(() => {
                            console.log('Update lat and lon status successfully');
                        })
                        .catch(error => {
                            console.log('Failed to lat and lon status error:', error);
                            // 20250923  handleAxiosError(error, "RobotOperation.js", "send_command_to_selected_robots()");
                        });
                }
                catch (error) {
                    //20250923 handleAxiosError(error, "RobotOperation.js", "send_command_to_selected_robots()");
                }
                //*** Create Json object frame and send it to Robots ***//
                var obj = new Object();
                //PlantID
                obj.PID = PlantID;
                obj.FID = user.robotID;
                //*** IF command is OFF then we send frame to stop robot operation ***//
                if (command === "OFF") obj.OPN = command;
                //*** IF command is RTP/RTCS then we send frame to robot operation  ***//

                //*** IF command is F/B/S then we send frame to robot operation  ***//
                if (command !== "OFF") {
                    obj.Cmd = command;
                    obj.Turn = turn;
                    obj.Spd = 255;
                    obj.GC = Current_grass_cutter_status;
                    obj.SP = Current_sprayer_status;
                    obj.SO = Current_sowing_status;
                    obj.CB = 0;
                    obj.MB = 0;
                    obj.TL = 0;
                    //obj.GC1 = Current_grass_cutter_status;
                    //obj.SP1 = Current_sprayer_status;
                    //obj.SO1 = Current_sowing_status;
                    //obj.CB1 = 0;
                    //obj.MB1 = 0;
                    //obj.CTS = cts;
                }
                var command_message = JSON.stringify(obj);
                try {
                    send_command_message_to_robot(command_message)
                    setItemChecked(true);
                    console.log(command_message)
                }
                catch (e) {
                    //handleTryCatchError(e, "RobotOperation.js", "client1.on(error)")
                }
            }
            );
        }
        setSentCommandButtonActive(btn, robotid, div, "SendCommand")
    };

    //*** Stop robots operation ***//
    const stop_selected_robots = (btn, robotID, div) => {
        send_command_to_selected_robots("S", "D", btn, robotID);
        setSentCommandButtonActive(btn, robotID, div, "SendCommand");
        //Temp comment on 20231018 RefreshCommandStatus();
    };
    //*** Stop robots operation ***//
    const stop_selected_robots1 = (btn, robotID, div, event) => {
        //alert("stop1");
        //alert(event)
        //if(event.type==="Click")
        event.preventDefault();
        console.log("stopped");
        //alert("stop");
        send_command_to_selected_robots("S", "D", btn, robotID);
        setSentCommandButtonActive(btn, robotID, div, "SendCommand");
        //Temp comment on 20231018 RefreshCommandStatus();
    };

    // Display Operation Modal Popup
    function Get_more(dvmodal, robotID) {
        setIsModalOpen(true);
        setModalRobotId(robotID);
        var divmodal = document.getElementById(dvmodal);
        divmodal.scrollIntoView();
        divmodal.style.display = "block";
        //setSentCommandButtonActive("btnGetMore" + robotID, robotID, "divGetMore" + robotID, "SendCommand")
    };
    // Hide Operation Modal Popup  
    const get_control_panel = (dvmodal) => {
        setIsModalOpen(false);
        setModalRobotId(null);
        var dvimodal = document.getElementById(dvmodal);
        dvimodal.style.display = "none";
    };

    //*** Get single robot operation page ***//
    const get_single_robot_operation = (robotID, plantID) => {
        sessionStorage.setItem("robotID", robotID);
        window.location.href = "/#/PlantRobotOperation?rid=" + robotID + "&pid=" + plantID + "";
        //window.location.href = "http://bhuhit.com/#/PlantRobotOperation?rid=" + robotID + "&pid=" + plantID + "";
    };
    const handleToggle = (robotID) => {
        for (var obj = 1; obj <= 25; obj++) {
            //alert(obj)
            //setValue(value);
            if (obj === robotID) setValue(!value);
            //if (obj !== robotID) setValue(value);
        }

    }
    //*** React hook to refresh page if any changes, page will auto refresh ***//
    useEffect(() => {
        fetchData();
        //const interval = setInterval(() => {
        // fetchData();
        // }, 900000);
        // //Clearing the interval
        // return () => clearInterval(interval);
    }, [])
    useEffect(() => {
        console.log(data)
    }, [data])
    //*** Fetch data for multiple robot operation page ***//
    const fetchData = async () => {
        // alert("fetchdata");
        var plant_id = sessionStorage.getItem("user_plantid");
        try {
            let response = await AxiosInstance.get("/PlantRobotsOperation?pid=" + plant_id + "&rt=multiple")
            setData(response.data);
            setList(response.data);
            setItemChecked(false);
        }

        catch (error) {
            console.log(error.message);
            //handleTryCatchError(error, "RobotOperation.js", "client1.on(error)")
            //handleAxiosError(error, "RobotOperation.js", "fetchData()");
        }
    }
    useEffect(() => {
        const interval = setInterval(() => {
            //checkRobotsConnectivity();
            //const currentTime = Math.floor((Date.now() - startTime) / 1000);
            //window.parent.postMessage({ type: 'camera-time', time: currentTime }, '*');
            // setRobotConnectedTime((currentTime));
        }, 1000);
        //Clearing the interval
        return () => clearInterval(interval);
        //const loop = (i) => {
        //if (i < 10) {
        //    setTimeout(() => {
        //        //setCount(i + 1);
        //        checkRobotsConnectivity();
        //        loop(i + 1);
        //        console.log("Sent frame to check robot connectivity");
        //    }, 1000);
        //}

        //};
        //loop(0);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const currentTime = Date.now();
            const previousTime = previousTimeRef.current;
            const diffInSeconds = (currentTime - previousTime) / 1000;
            const diffInMinutes = (currentTime - previousTime) / 60000;
            const diffInHours = (currentTime - previousTime) / 360000;
            const secs = Math.floor(diffInSeconds % 60);
            const hrs = Math.floor(secs / 3600);
            const mins = Math.floor((diffInSeconds % 3600) / 60);
            //alert(sec);
            const formatedTime = hrs.toString().padStart(2, "0") + ":" + mins.toString().padStart(2, "0") + ":" + secs;
            setRobotConnectedTime(formatedTime);
            // alert(diffInSeconds);
            if (diffInSeconds > 1) {
                console.log('More than 2 seconds passed — run your code here');

                //setCurrentTime(new Date());

                // Update previous time
                //previousTimeRef.current = currentTime;
            } else {
                console.log(`Only ${diffInSeconds.toFixed(1)} seconds passed — skipping`);
            }
        }, 1000); // check every 1 second

        return () => clearInterval(interval); // cleanup
    }, []);

    // ----------------------------------------------------
    // Global 1-second interval → only refresh UI timer
    // ----------------------------------------------------
    useEffect(() => {
        const t = setInterval(() => {
            setList(prev => [...prev]); // force re-render ONLY timers
        }, 1000);
        return () => clearInterval(t);
    }, []);

    //const formatTime = (date) => {
    //    const pad = (num) => String(num).padStart(2, '0');
    //    const hours = pad(date.getHours());
    //    const minutes = pad(date.getMinutes());
    //    const seconds = pad(date.getSeconds());

    //    return `${hours}:${minutes}:${seconds}`;
    //};

    const handleTouchEnd = (event) => {
        console.log("Touch Ended");
    }

    const cmdBase = {
        backgroundColor: "#f0f0f0",
        border: "1px solid #ccc",
        padding: "8px 0",
        textAlign: "center",
        borderRadius: "6px",
        cursor: "pointer",
        marginBottom: "8px",
        userSelect: "none"
    };
    const getBatteryColor = (v) => {
        if (v > 60) return "#99cc33";
        if (v > 30) return "#FFC107";
        return "#F44336";
    };
    //const getTankColor = (level) => {
    //    if (level > 60) return "#4CAF50";     // Green
    //    if (level > 30) return "#FF9800";     // Orange
    //    return "#F44336";                     // Red
    //};


    //*** Send a drive command (Joystick / Direction Pad / Speed) to the robots ***//
    // Targets: every robot that is CHECKED in the list; if none is checked, only the robot whose popup is open.
    // Same MQTT frame as send_command_to_selected_robots, but:
    //   - Spd is the speed chosen on the Speed controller (not a fixed 255)
    //   - the database is written only when the command CHANGES (not on every joystick tick)
    //   - GC / SP / SO are read from the robot's toggles; a pure STOP (S + D) sends them as 0 (same as the old buttons)
    const send_drive_to_robots = (command, turn, spd) => {
        const all = List || [];
        // Popup open ("More")  -> SINGLE robot operation: only that robot.
        // Popup closed         -> every robot that is ticked in the list.
        let targets = modalRobotId !== null
            ? all.filter((r) => String(r.robotID) === String(modalRobotId))
            : all.filter((r) => r.selected);
        if (targets.length === 0) return;
        if (command !== "S") setSelectedCmd("");   // driving started -> no button (e.g. Stop) stays highlighted
        const pid = sessionStorage.getItem("user_plantid");
        const isStop = command === "S" && turn === "D";
        const speedToSend = isStop ? 0 : spd;

        targets.forEach((r) => {
            const gc = !isStop && r.grasscutterselected ? 1 : 0;
            const sp = !isStop && r.sprayerselected ? 1 : 0;
            const so = !isStop && r.sowingselected ? 1 : 0;

            const obj = {
                PID: pid, FID: r.robotID, Cmd: command, Turn: turn, Spd: speedToSend,
                GC: gc, SP: sp, SO: so, CB: 0, MB: 0, TL: 0,
            };
            try { send_command_message_to_robot(JSON.stringify(obj)); } catch (e) { console.log(e.message); }

            const key = command + turn;
            if (lastDriveLoggedRef.current[r.robotID] !== key) {
                lastDriveLoggedRef.current[r.robotID] = key;
                try {
                    AxiosInstance.get("/PlantRobotOperation/addcmd?pid=" + r.plantID + "&uid=" + sruserID + "&rid=" + r.robotID
                        + "&cmd=" + command + "&tun=" + turn + "&spd=" + speedToSend + "&gc=" + gc + "&sp=" + sp + "&so=" + so
                        + "&cb=0&mb=0&tl=0&cid=1").catch((error) => console.log("addcmd failed:", error));
                } catch (error) { console.log(error); }
            }
        });
    };
    //*** Text shown above the controls: who will receive the commands ***//
    const get_drive_target_label = (user) => {
        const popupRobot = user || (modalRobotId !== null ? (List || []).find((r) => String(r.robotID) === String(modalRobotId)) : null);
        if (modalRobotId !== null && popupRobot) return "Controls → " + (popupRobot.robotName || popupRobot.robotID) + " only (popup)";
        const checked = (List || []).filter((r) => r.selected);
        if (checked.length > 0) return "Controls → " + checked.length + " checked robot" + (checked.length > 1 ? "s" : "");
        return "Tick at least one robot to control it";
    };

    const JoystickRobotOperation = (rbtID) => {
        sessionStorage.removeItem("rbtID");
        sessionStorage.setItem("rbtID", rbtID);
        navigate(`/robot-control?pid=${srPlantID}&fid=${rbtID}`);
    }

    const ScanFarm = () => {
        //navigate(`/agri-dashboard`);
        navigate(`/agri-dashboard`);
    }

    //*** "Use Joystick" on the page bars: opens the single-robot Joystick page (same JoystickRobotOperation as the popup link).
    //    Robot = the popup's robot when a popup is open, otherwise the ONE ticked robot. ***//
    const joystickTarget = (() => {
        const all = List || [];
        if (modalRobotId !== null) return all.find((r) => String(r.robotID) === String(modalRobotId)) || null;
        const checked = all.filter((r) => r.selected);
        return checked.length === 1 ? checked[0] : null;
    })();

    //*** Connect / Disconnect from the top bar and the sticky dock.
    //    Same call the popup button makes (Create_broadcasting_command_message) for every target robot, with the CURRENT list
    //    (the old path read the stale selectedList state and never switched its label to "Disconnect").
    //    Targets = ticked robots; none ticked -> the popup robot. ***//
    const isRobotConnected = (r) => !!connectedAt[String(r.robotID)] || r.broadcastStatus === "Connected";
    const connectTargets = (() => {
        const all = List || [];
        const ticked = all.filter((r) => r.selected);
        if (ticked.length > 0) return ticked;
        return modalRobotId !== null ? all.filter((r) => String(r.robotID) === String(modalRobotId)) : [];
    })();
    const allTargetsConnected = connectTargets.length > 0 && connectTargets.every(isRobotConnected);
    const connect_or_disconnect_targets = () => {
        if (connectTargets.length === 0) return;
        Client_subscribe_to_mqtt_topic();
        // "Connect" only talks to robots that are NOT connected yet (the same message would switch a connected robot off);
        // "Disconnect" (every target is connected) talks to all of them.
        connectTargets
            .filter((r) => (allTargetsConnected ? true : !isRobotConnected(r)))
            .forEach((r) => Create_broadcasting_command_message("btnConnect_1" + r.robotID, r.robotID, "divConnect_1" + r.robotID));
    };

    //*** Props for the TOP and BOTTOM control bars (same handlers the old buttons used) ***//
    const barProps = {
        masterChecked,
        onMasterCheck,
        selectedCount: (List || []).filter((r) => r.selected).length,
        selectedCmd,
        setSelectedCmd,
        onConnect: connect_or_disconnect_targets,
        connectLabel: allTargetsConnected ? "Disconnect" : "Connect",
        connectActive: allTargetsConnected,
        onScanFarm: () => ScanFarm(),
        joystickTargetName: joystickTarget ? (joystickTarget.robotName || joystickTarget.robotID) : null,
        onUseJoystick: () => { if (joystickTarget) JoystickRobotOperation(joystickTarget.robotID); },
        onCharging: () => send_command_to_selected_robots("RTCS", "D"),
        onParking: () => send_command_to_selected_robots("RTP", "D"),
        onStop: (e) => { stop_selected_robots("btnStop", 0, "divStop", e); if (modalRobotId !== null) send_drive_to_robots("S", "D", 0); },
        onOff: () => { send_command_to_selected_robots("OFF"); stopViewing(); },
        speed: pageSpeed,
        onSpeedChange: (v) => { speedTouchedRef.current = Date.now(); setPageSpeed(v); },
        onDrive: send_drive_to_robots,
        targetLabel: get_drive_target_label(null),
        hasPopupRobot: modalRobotId !== null,
        onHeight: setDockHeight,
        showSelectedOnly,
        onToggleSelectedOnly: () => setShowSelectedOnly((v) => !v),
        showDrive: showPageDrive,
        onToggleDrive: () => setShowPageDrive((v) => !v),
    };


    return (
        <>
            <style>{RB_CSS}</style>
            <div>
                <div>
                    {/*<h3 style={{ marginTop: "1%", color: "#000" }}>Multiple Robot Operation</h3>*/}
                    <div
                        style={{
                            border: "1px solid #c0c0c0",
                            borderRadius: "5px",
                            width: "99%",
                            backgroundColor: "#fff",
                        }}
                    >
                        <div className="container" style={{ backgroundColor: "#fff" }}>

                            {/*<div className="container-fluid">*/}

                            {/*    */}{/* ---------------------- ROW 1 ------------------------ */}
                            {/*    <div className="row align-items-center mb-2">*/}

                            {/*        */}{/* Title */}
                            {/*        <div className="col-12 col-md-4 mb-2" style={{ fontSize: "20px", fontWeight: 600 }}>*/}
                            {/*            Multiple Robot Operations*/}
                            {/*        </div>*/}

                            {/*        */}{/* Search */}
                            {/*        <div className="col-12 col-md-4 mb-2">*/}
                            {/*            <input*/}
                            {/*                type="text"*/}
                            {/*                placeholder="Search Results"*/}
                            {/*                value={searchTerm}*/}
                            {/*                onChange={handleSearch}*/}
                            {/*                className="form-control"*/}
                            {/*            />*/}
                            {/*        </div>*/}

                            {/*        */}{/* Charging */}
                            {/*        <div*/}
                            {/*            className="col-6 col-md-2"*/}
                            {/*            style={{*/}
                            {/*                ...cmdBase,*/}
                            {/*                backgroundColor: selectedCmd === "Charging" ? "#99cc33" : ""*/}
                            {/*            }}*/}
                            {/*            onClick={() => {*/}
                            {/*                setSelectedCmd("Charging");*/}
                            {/*                send_command_to_selected_robots("RTCS", "D");*/}
                            {/*            }}*/}
                            {/*            onMouseEnter={(e) =>*/}
                            {/*            (e.target.style.backgroundColor =*/}
                            {/*                selectedCmd === "Charging" ? "#99cc33" : "#f6fbb3")*/}
                            {/*            }*/}
                            {/*            onMouseLeave={(e) =>*/}
                            {/*            (e.target.style.backgroundColor =*/}
                            {/*                selectedCmd === "Charging" ? "#99cc33" : "")*/}
                            {/*            }*/}
                            {/*        >*/}
                            {/*            Charging*/}
                            {/*        </div>*/}

                            {/*        */}{/* Parking */}
                            {/*        <div*/}
                            {/*            className="col-6 col-md-2"*/}
                            {/*            style={{*/}
                            {/*                ...cmdBase,*/}
                            {/*                backgroundColor: selectedCmd === "Parking" ? "#99cc33" : ""*/}
                            {/*            }}*/}
                            {/*            onClick={() => {*/}
                            {/*                setSelectedCmd("Parking");*/}
                            {/*                send_command_to_selected_robots("RTP", "D");*/}
                            {/*            }}*/}
                            {/*            onMouseEnter={(e) =>*/}
                            {/*            (e.target.style.backgroundColor =*/}
                            {/*                selectedCmd === "Parking" ? "#99cc33" : "#f6fbb3")*/}
                            {/*            }*/}
                            {/*            onMouseLeave={(e) =>*/}
                            {/*            (e.target.style.backgroundColor =*/}
                            {/*                selectedCmd === "Parking" ? "#99cc33" : "")*/}
                            {/*            }*/}
                            {/*        >*/}
                            {/*            Parking*/}
                            {/*        </div>*/}

                            {/*    </div>*/}

                            {/*    */}{/* ---------------------- ROW 2 ------------------------ */}
                            {/*    <div className="row align-items-center">*/}

                            {/*        */}{/* Master Checkbox */}
                            {/*        <div className="col-12 col-md-1 mb-2">*/}
                            {/*            <input*/}
                            {/*                type="checkbox"*/}
                            {/*                checked={masterChecked}*/}
                            {/*                onChange={(e) => onMasterCheck(e)}*/}
                            {/*            />{" "}*/}
                            {/*            All*/}
                            {/*        </div>*/}

                            {/*        */}{/* Command Buttons */}
                            {/*        {[*/}
                            {/*            { label: "Connect", click: () => check_selected_robots_connected_status() },*/}
                            {/*            { label: "Forward", click: () => send_command_to_selected_robots("F", "D") },*/}
                            {/*            { label: "Backward", click: () => send_command_to_selected_robots("B", "D") },*/}
                            {/*            { label: "Left", click: () => send_command_to_selected_robots("None", "L") },*/}
                            {/*            { label: "Stop Turn", click: () => send_command_to_selected_robots("None", "D") },*/}
                            {/*            { label: "Right", click: () => send_command_to_selected_robots("None", "R") },*/}
                            {/*            { label: "Stop", click: (e) => stop_selected_robots("btnStop", 0, "divStop", e) },*/}
                            {/*            { label: "Off", click: () => send_command_to_selected_robots("OFF") }*/}
                            {/*        ].map((cmd, i) => (*/}
                            {/*            <div*/}
                            {/*                key={i}*/}
                            {/*                className="col-6 col-md-1 mb-2"*/}
                            {/*                style={{*/}
                            {/*                    ...cmdBase,*/}
                            {/*                    backgroundColor: selectedCmd === cmd.label ? "#99cc33" : ""*/}
                            {/*                }}*/}
                            {/*                onClick={() => {*/}
                            {/*                    setSelectedCmd(cmd.label);*/}
                            {/*                    cmd.click();*/}
                            {/*                }}*/}
                            {/*                onMouseEnter={(e) =>*/}
                            {/*                (e.target.style.backgroundColor =*/}
                            {/*                    selectedCmd === cmd.label ? "#99cc33" : "#f6fbb3")*/}
                            {/*                }*/}
                            {/*                onMouseLeave={(e) =>*/}
                            {/*                (e.target.style.backgroundColor =*/}
                            {/*                    selectedCmd === cmd.label ? "#99cc33" : "")*/}
                            {/*                }*/}
                            {/*            >*/}
                            {/*                {cmd.label}*/}
                            {/*            </div>*/}
                            {/*        ))}*/}

                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="container-fluid">

                                {/* ---------------------- ROW 1 ------------------------ */}
                                <div className="row align-items-center mb-2">

                                    {/* Title */}
                                    <div className="col-12 col-md-6 mb-2" style={{ fontSize: "21px", fontWeight: 600 }}>
                                        Multiple Robot Operations
                                    </div>

                                    {/* Search */}
                                    <div className="col-12 col-md-6 mb-2">
                                        <input
                                            type="text"
                                            placeholder="Search Results"
                                            value={searchTerm}
                                            onChange={handleSearch}
                                            className="form-control"
                                        />
                                    </div>

                                </div>

                                {/* ---------------------- TOP BAR ------------------------ */}
                                <RobotTopBar {...barProps} />
                            </div>


                            <div className="grid">
                                {(showSelectedOnly ? List.filter((r) => r.selected) : List).map((user) => {
                                    return [
                                        <div key={user.robotID} style={{ backgroundColor: "fff" }}>
                                            <div style={{ float: "left" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={user.selected}
                                                    className="form-check-input"
                                                    id="rowcheck{user.id}"
                                                    onChange={(e) => onItemCheck(e, user)}
                                                />
                                            </div>

                                            <div className="col container_multi_robots" style={{ position: 'relative', backgroundColor: "aliceblue", cursor: "pointer" }}>
                                                <div className="col camera_connection_status">
                                                    {/*<a style={{ cursor: 'Pointer' }} id={user.robotID + IPAddress} onClick={() => show_camera("F", "D")} ><i class="fa fa-video-camera" style={{ color: 'yellow', fontSize: "20px", width: "100%" }}></i></a>*/}

                                                    <a
                                                        id={"btnCamera1_" + user.robotID}
                                                        className="modal_connect_stop_link d-flex align-items-center"
                                                        onClick={() => {
                                                            const isThisRobotCameraOn = isCameraOn && activeCameraRobotId === user.robotID;

                                                            if (isThisRobotCameraOn) {
                                                                stopViewing();
                                                                setIsCameraOn(false);
                                                                setActiveCameraRobotId(null);
                                                            } else {
                                                                // Only one underlying WebRTC connection exists today
                                                                // (see CHANNEL_NAME) — if a different robot's camera
                                                                // is currently on, stop it first so its icon doesn't
                                                                // stay lit incorrectly once this robot takes over.
                                                                if (isCameraOn) {
                                                                    stopViewing();
                                                                }
                                                                setActiveCameraRobotId(user.robotID);
                                                                startViewing();
                                                                setIsCameraOn(true);
                                                            }
                                                        }}
                                                        style={{
                                                            cursor: "pointer",
                                                            textDecoration: "none",
                                                            whiteSpace: "nowrap"
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                (isCameraOn && activeCameraRobotId === user.robotID)
                                                                    ? cameraon
                                                                    : cameraoff
                                                            }
                                                            alt={(isCameraOn && activeCameraRobotId === user.robotID) ? "Camera On" : "Camera Off"}
                                                            style={{
                                                                width: "36px",
                                                                height: "36px",
                                                                padding: "5px",
                                                                objectFit: "contain",
                                                                borderRadius: "50%",
                                                                background: (isCameraOn && activeCameraRobotId === user.robotID) ? "#99cc33" : "rgba(255,255,255,0.92)",
                                                                border: "2px solid " + ((isCameraOn && activeCameraRobotId === user.robotID) ? "#fff" : "rgba(0,0,0,0.15)"),
                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.45)",
                                                                marginRight: "0px"
                                                            }}
                                                        />

                                                        {(isCameraOn && activeCameraRobotId === user.robotID) ? "" : ""}
                                                    </a>
                                                </div>

                                                {user.controllerBatteryStatus ?
                                                    (
                                                        <div class="dvcb col" id={"dvCB" + user.robotID}>
                                                            CB&nbsp;<BatteryGauge class="controllerbattery" id={"CB" + user.robotID} value={user.controllerBatteryStatus}
                                                                customization={{
                                                                    batteryMeter: {
                                                                        fill: getBatteryColor(user.controllerBatteryStatus),
                                                                    },
                                                                }}

                                                            />
                                                        </div>
                                                    ) :
                                                    (
                                                        <div class="dvcb col" id={"dvCB1" + user.robotID}>
                                                            CB&nbsp;<BatteryGauge class="controllerbattery" id={"CB1" + user.robotID} value={0} />
                                                        </div>
                                                    )
                                                }
                                                {user.motorBatteryStatus ?
                                                    (
                                                        <div class="dvmb col" id={"dvMB" + user.robotID}>
                                                            MB&nbsp;<BatteryGauge className="motorbattery" id={"MB" + user.robotID} value={user.motorBatteryStatus}
                                                                customization={{
                                                                    batteryMeter: {
                                                                        fill: getBatteryColor(user.motorBatteryStatus),
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    ) :
                                                    (
                                                        <div class="dvmb col" id={"dvMB1" + user.robotID}>
                                                            MB&nbsp;<BatteryGauge className="motorbattery" id={"MB1" + user.robotID} value={0} />
                                                        </div>
                                                    )
                                                }

                                                {IPAddress && (activeCameraRobotId === user.robotID) ? (
                                                    <div>
                                                        {/*<Helmet>*/}
                                                        {/*    <meta property="og:image" content={user.ipAddress} />*/}
                                                        {/*    <meta httpEquiv="Content-Security-Policy" content={"img-src 'self'" + user.ipAddress} />*/}
                                                        {/*    <meta httpEquiv="Content-Security-Policy" content={"media-src 'self'" + user.ipAddress} />*/}
                                                        {/*    <meta httpEquiv="Content-Security-Policy" content={"connect-src 'self'" + user.ipAddress} />*/}
                                                        {/*    <meta httpEquiv="Content-Security-Policy" content={"frame-src 'self'" + user.ipAddress} />*/}
                                                        {/*</Helmet>*/}
                                                        {/* <Iframe id={"Iframe1" + user.robotID} key={"Iframe1" + user.robotID} url="http://192.168.1.16:8888/" className='responsive-iframe_1 inneriframe1' loading="lazy" allow="microphone;camera"></Iframe>*/}
                                                        <video
                                                            id={"Iframe1" + user.robotID}
                                                            key={"Iframe1" + user.robotID}
                                                            ref={videoRef}
                                                            autoPlay
                                                            playsInline
                                                            controls
                                                            className="pi-viewer__video responsive-iframe_1 inneriframe1"
                                                            style={{ objectFit: 'contain', width: '100%', height: '100%', background: '#000' }}
                                                        />
                                                    </div>
                                                )
                                                    : (
                                                        <Iframe id={"Iframe2" + user.robotID} key={"Iframe2" + user.robotID} url={bg} className='responsive-iframe_1 inneriframe1' loading="lazy" allow="microphone;camera"></Iframe>
                                                    )
                                                }
                                                &nbsp;
                                                <div style={{ marginTop: "55%", backgroundColor: "aliceblue", marginLeft: "40%", fontSize: "120%" }}>
                                                    <div id={"dvPL" + user.robotID} class="PowerLight">
                                                        {

                                                            user.currentCommandStatus === 'OFF' ?
                                                                (
                                                                    <div id={"PL" + user.robotID} ><PowerLight state={user.towerlampstatus} id={"PL_" + user.robotID} /></div>
                                                                )
                                                                :
                                                                (
                                                                    <></>
                                                                )
                                                        }

                                                        {
                                                            user.currentCommandStatus === 'S' || user.currentCommandStatus === 'New' || user.currentCommandStatus === '' || user.currentCommandStatus === null ?
                                                                (
                                                                    <div id={"PL" + user.robotID} ><PowerLight state={user.towerlampstatus} id={"PL_" + user.robotID} /></div>
                                                                )
                                                                :
                                                                (
                                                                    <></>
                                                                )
                                                        }

                                                        {user.currentCommandStatus === "Moving Forward" || user.currentCommandStatus === "Moving Backward" ||
                                                            user.currentCommandStatus === "Forward Left" || user.currentCommandStatus === "Backward Left" ||
                                                            user.currentCommandStatus === "Forward Right" || user.currentCommandStatus === "Backward Right"
                                                            ?
                                                            (
                                                                <div id={"PL" + user.robotID}>
                                                                    <PowerLight state={user.towerlampstatus} id={"PL_" + user.robotID} />
                                                                </div>
                                                            )
                                                            : (
                                                                <></>
                                                            )
                                                        }


                                                    </div>

                                                    <div class="display_robot_name">
                                                        {user.robotName}
                                                        {/*<div>{IPAddress}</div>*/}
                                                    </div>

                                                    <div key={user.robotID} id={"dv" + user.robotID} class="control_panel" style={{ display: "none", backgroundColor: "#ffffff" }}>
                                                        {/*<div className="icon-forward-2">*/}
                                                        {/*     <a id={"btnStart" + user.robotID} class="operation-icon"  onClick={() => send_command_to_selected_robots("F", "D")} ><i class="fa fa-caret-square-o-up"></i></a>*/}
                                                        {/*</div>*/}
                                                        {/*<div className="icon-backward-2" style={{ backgroundColor:"black"} }>*/}
                                                        {/*      <a id={"btnReturn" + user.robotID} class="operation-icon" onClick={() => send_command_to_selected_robots("B", "D")} ><i class="fa fa-caret-square-o-down"></i></a>*/}
                                                        {/*</div>*/}
                                                        {/*<div className="icon-left">*/}
                                                        {/*        <a id={"btnLeft" + user.robotID} class="operation-icon" onClick={() => send_command_to_selected_robots("None", "L")} ><i class="fa fa-caret-square-o-left"></i></a>*/}
                                                        {/*</div>*/}
                                                        {/*<div className="icon-right">*/}
                                                        {/*        <a id={"btnRight" + user.robotID} class="operation-icon" onClick={() => send_command_to_selected_robots("None", "R")} ><i class="fa fa-caret-square-o-right"></i></a>*/}
                                                        {/*</div>*/}
                                                        {/*<div className="icon-turn_stop-2">*/}
                                                        {/*        <a id={"btnTurnStop" + user.robotID} class="operation-icon" onClick={() => send_command_to_selected_robots("None", "D")} ><i class="fa fa-dot-circle-o"></i></a>*/}
                                                        {/*</div>*/}

                                                        {/*<div className="icon-forward-right">*/}
                                                        {/*        <a id="btnForwardRight" class="operation-icon" onClick={() => send_command_to_selected_robots("F", "R")}><i class="fa fa-share"></i></a>*/}
                                                        {/*</div>*/}

                                                        {/*<div className="icon-forward-left">*/}
                                                        {/*        <a id="btnForwardLeft" class="operation-icon" onClick={() => send_command_to_selected_robots("F", "L")}><i class="fa fa-reply"></i></a>*/}
                                                        {/*</div>*/}

                                                        {/*<div className="icon-backward-right-2">*/}
                                                        {/*        <a id="btnBackwardRight" class="operation-icon" onClick={() => send_command_to_selected_robots("B", "R")}><i class="fa fa-reply fa-rotate-180"></i></a>*/}
                                                        {/*</div>*/}

                                                        {/*<div className="icon-backward-left-2">*/}
                                                        {/*        <a id="btnBackwardLeft" class="operation-icon" onClick={() => send_command_to_selected_robots("B", "L")}><i class="fa fa-share fa-rotate-180"></i></a>*/}
                                                        {/*</div>*/}



                                                    </div>



                                                    {user.broadcastStatus === 'Disconnected' ?
                                                        (
                                                            <div className="icon-connect_1 icon-size" id={"divConnect" + user.robotID}>
                                                                <a id={"btnConnect" + user.robotID} class="operation-icon1" onClick={() => {
                                                                    Create_broadcasting_command_message("btnConnect" + user.robotID, user.robotID, "divConnect" + user.robotID);
                                                                    startViewing();
                                                                }}><i class="fa fa-toggle-off icon-size" style={{ color: '#cae00d' }}></i>&nbsp;Connect</a>
                                                            </div>
                                                            /*<div className="connection_status"><i class="fa fa-toggle-off" style={{ fontSize: '25px', color: 'red' }}></i>&nbsp;Disconnected</div>*/
                                                        ) :
                                                        (
                                                            <div className="icon-connect_1 icon-size" id={"divConnect" + user.robotID}>
                                                                <a id={"btnConnect" + user.robotID} class="operation-icon1" onClick={() => {
                                                                    Create_broadcasting_command_message("btnConnect" + user.robotID, user.robotID, "divConnect" + user.robotID);

                                                                }} >&nbsp;Disconnect</a>
                                                            </div>
                                                            /*<div className="connection_status"><i class="fa fa-toggle-on" style={{ fontSize: '25px', color: 'lime' }}></i>&nbsp;Connected</div>*/
                                                        )}

                                                    {/*<div className="icon-connect_1 icon-size">*/}
                                                    {/*        <a id={"btnConnect" + user.robotID} class="operation-icon1" onClick={() => Create_broadcasting_command_message(user.robotID)}><i class="fa fa-cogs icon-size"></i>&nbsp;Connect</a>*/}
                                                    {/*</div>*/}

                                                    <div id={"divGetMore" + user.robotID} className="icon-control_panel_1 icon-size" onClick={() => Get_more("dvmodal" + user.robotID, user.robotID)}>
                                                        <a id={"btnGetMore" + user.robotID} class="operation-icon1" onClick={() => Get_more("dvmodal" + user.robotID, user.robotID)}><i class="fa fa-ellipsis-h icon-size" style={{ color: '#cae00d' }}></i>&nbsp;More</a>
                                                    </div>

                                                    <div className="icon-stop-1 icon-size" id={"divRobotStop" + user.robotID}>
                                                        <a id={"btnRobotStop" + user.robotID} class="operation-icon1" onClick={() => stop_selected_robots("btnRobotStop" + user.robotID, user.robotID, "divRobotStop" + user.robotID)}><i class="fa fa-circle-o-notch" style={{ color: '#cae00d' }}></i>&nbsp;Stop</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div></div>
                                            {/*<div className="row">*/}
                                            {/*    <div class="col-sm-1 gc-sp-text">GC:</div>*/}
                                            {/*    <div class="col-sm-3">*/}
                                            {/*        <input*/}
                                            {/*            className="react-switch-checkbox"*/}
                                            {/*            id={user.robotID + "GCInputToggle"}*/}
                                            {/*            name={user.robotID + "GCInputToggle"}*/}
                                            {/*            key={user.robotID + "GCInputToggle"}*/}
                                            {/*            type="checkbox"*/}
                                            {/*            checked={user.grasscutterselected}*/}
                                            {/*            onChange={(e) => onGrassCutterCheck(e, user)}*/}
                                            {/*        />*/}
                                            {/*        <label key={user.robotID + 'lblGC'} id={user.robotID + "lblGC"}*/}
                                            {/*            style={{ background: user.grasscutterselected ? '#99cc33' : 'lightgray'}}*/}
                                            {/*            className="react-switch-label"*/}
                                            {/*            htmlFor={user.robotID + "GCInputToggle"}*/}
                                            {/*        >*/}
                                            {/*            <span id={user.robotID + "GCspan"} name={user.robotID + "GCspan"} key={user.robotID + "GCspan"} className={`react-switch-button`}></span>*/}
                                            {/*        </label>*/}
                                            {/*    </div>*/}
                                            {/*    <div class="col-sm-1">SP:</div>*/}
                                            {/*    <div class="col-sm-3">*/}
                                            {/*        <input className="react-switch-checkbox"*/}
                                            {/*            id={user.robotID + "SPInputToggle"}*/}
                                            {/*            name={user.robotID + "SPInputToggle"}*/}
                                            {/*            key={user.robotID + "SPInputToggle"}*/}
                                            {/*            type="checkbox"*/}
                                            {/*            checked={user.sprayerselected}*/}
                                            {/*            onChange={(e) => onSprayerCheck(e, user)}*/}
                                            {/*        />*/}
                                            {/*        <label key={user.robotID + 'lblSP'} id={user.robotID + "lblSP"}*/}
                                            {/*            style={{ background: user.sprayerselected ? '#99cc33' : 'lightgray'}}*/}
                                            {/*            className="react-switch-label"*/}
                                            {/*            htmlFor={user.robotID + "SPInputToggle"}*/}
                                            {/*           >*/}
                                            {/*            <span id={user.robotID + "SPspan"} name={user.robotID + "SPspan"} key={user.robotID + "span"} className={`react-switch-button`} />*/}
                                            {/*        </label>*/}
                                            {/*    </div>*/}
                                            {/*    <div class="col-sm-1 gc-sp-text">SO:</div>*/}
                                            {/*    <div class="col-sm-3">*/}
                                            {/*        <input className="react-switch-checkbox"*/}
                                            {/*            id={user.robotID + "SOInputToggle"}*/}
                                            {/*            name={user.robotID + "SOInputToggle"}*/}
                                            {/*            key={user.robotID + "SOInputToggle"}*/}
                                            {/*            type="checkbox"*/}
                                            {/*            checked={user.sowingselected}*/}
                                            {/*            onChange={(e) => onSowingCheck(e, user)}*/}
                                            {/*        />*/}
                                            {/*        <label key={user.robotID + 'lblSO'} id={user.robotID + "lblSO"}*/}
                                            {/*            style={{ background: user.sowingselected ? '#99cc33' : 'lightgray' }}*/}
                                            {/*            className="react-switch-label"*/}
                                            {/*            htmlFor={user.robotID + "SOInputToggle"}*/}
                                            {/*        >*/}
                                            {/*            <span id={user.robotID + "SO1span"} name={user.robotID + "SO1span"} key={user.robotID + "span"} className={`react-switch-button`} />*/}
                                            {/*        </label>*/}
                                            {/*    </div>*/}
                                            {/*    <div class="watertl">*/}
                                            {/*        Live Tank Level:{tankWaterLevelStatus}%*/}
                                            {/*    </div>*/}
                                            {/*  </div>*/}
                                            <div className="row align-items-center" style={{ marginTop: "10px" }}>

                                                {/* GC */}
                                                <div className="col-3 col-sm-1 gc-sp-text">GC:</div>
                                                <div className="col-9 col-sm-3 mb-2">
                                                    <input
                                                        className="react-switch-checkbox"
                                                        id={user.robotID + "GCInputToggle"}
                                                        name={user.robotID + "GCInputToggle"}
                                                        key={user.robotID + "GCInputToggle"}
                                                        type="checkbox"
                                                        checked={user.grasscutterselected}
                                                        onChange={(e) => onGrassCutterCheck(e, user)}
                                                    />
                                                    <label
                                                        key={user.robotID + 'lblGC'}
                                                        id={user.robotID + "lblGC"}
                                                        style={{ background: user.grasscutterselected ? '#99cc33' : 'lightgray' }}
                                                        className="react-switch-label"
                                                        htmlFor={user.robotID + "GCInputToggle"}
                                                    >
                                                        <span
                                                            id={user.robotID + "GCspan"}
                                                            name={user.robotID + "GCspan"}
                                                            key={user.robotID + "GCspan"}
                                                            className="react-switch-button"
                                                        ></span>
                                                    </label>
                                                </div>

                                                {/* SP */}
                                                <div className="col-3 col-sm-1 gc-sp-text">SP:</div>
                                                <div className="col-9 col-sm-3 mb-2">
                                                    <input
                                                        className="react-switch-checkbox"
                                                        id={user.robotID + "SPInputToggle"}
                                                        name={user.robotID + "SPInputToggle"}
                                                        key={user.robotID + "SPInputToggle"}
                                                        type="checkbox"
                                                        checked={user.sprayerselected}
                                                        onChange={(e) => onSprayerCheck(e, user)}
                                                    />
                                                    <label
                                                        key={user.robotID + 'lblSP'}
                                                        id={user.robotID + "lblSP"}
                                                        style={{ background: user.sprayerselected ? '#99cc33' : 'lightgray' }}
                                                        className="react-switch-label"
                                                        htmlFor={user.robotID + "SPInputToggle"}
                                                    >
                                                        <span
                                                            id={user.robotID + "SPspan"}
                                                            name={user.robotID + "SPspan"}
                                                            key={user.robotID + "SPspan"}
                                                            className="react-switch-button"
                                                        ></span>
                                                    </label>
                                                </div>

                                                {/* SO */}
                                                <div className="col-3 col-sm-1 gc-sp-text">SO:</div>
                                                <div className="col-9 col-sm-3 mb-2">
                                                    <input
                                                        className="react-switch-checkbox"
                                                        id={user.robotID + "SOInputToggle"}
                                                        name={user.robotID + "SOInputToggle"}
                                                        key={user.robotID + "SOInputToggle"}
                                                        type="checkbox"
                                                        checked={user.sowingselected}
                                                        onChange={(e) => onSowingCheck(e, user)}
                                                    />
                                                    <label
                                                        key={user.robotID + 'lblSO'}
                                                        id={user.robotID + "lblSO"}
                                                        style={{ background: user.sowingselected ? '#99cc33' : 'lightgray' }}
                                                        className="react-switch-label"
                                                        htmlFor={user.robotID + "SOInputToggle"}
                                                    >
                                                        <span
                                                            id={user.robotID + "SO1span"}
                                                            name={user.robotID + "SO1span"}
                                                            key={user.robotID + "SO1span"}
                                                            className="react-switch-button"
                                                        ></span>
                                                    </label>
                                                </div>

                                                {/* Tank Level */}
                                                <div className="col-12 mt-1 watertl">

                                                    {/* ---------------- Row 2 : Tank Level + Uptime ---------------- */}
                                                    <div className="row align-items-center mt-2">

                                                        {/* Tank Level */}
                                                        <div
                                                            className="col-12 col-sm-5 mb-2 d-flex align-items-center gap-2 gc-sp-text"
                                                            id={user.robotID + "divTanlLevel"}
                                                        >
                                                            <strong>TL:</strong>
                                                            <TankLevel tankLevel={user.waterTankLevelStatus} />
                                                        </div>

                                                        {/* Uptime */}
                                                        <div
                                                            className="col-12 col-sm-7 mb-2 gc-sp-text"
                                                            id={user.robotID + "divOperationTime"}
                                                        >
                                                            <div className="text-sm-end d-flex justify-content-sm-end align-items-center gap-1">
                                                                {/*<strong>*/}
                                                                {/*    <i className="fa fa-history" style={{ color: "#000" }}></i>&nbsp;Uptime:*/}
                                                                {/*</strong>*/}
                                                                {/* {formatTime(getLiveSeconds(user))}*/}
                                                                {/* time since the robot connected (starts when the robot answers with FID + IP) */}
                                                                {connectedAt[String(user.robotID)] ? (
                                                                    <div className="rb-uptime" title="Time since this robot connected">
                                                                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                                        <span>Connected</span>
                                                                        <ConnectedTimer since={connectedAt[String(user.robotID)]} />
                                                                    </div>
                                                                ) : (user.broadcastStatus === "Connected" ? (
                                                                    <div className="rb-uptime rb-uptime-idle"><i className="fa fa-circle" aria-hidden="true"></i><span>Connected</span></div>
                                                                ) : null)}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>

                                            <div className="row gc-sp-text" id={"dvgcsp" + user.robotID} style={{ display: "block" }}>
                                                {/*<div class="col-2"></div>*/}
                                                {/*<span className="col-sm-2 col_gc_sp" style={{ backgroundColor:"yellow" }}> GC:&nbsp;</span>*/}
                                                <div key={user.robotID + 'divGCToggle'} id={user.robotID + 'divGCToggle'} className="col-sm-12 col_gc_sp1">
                                                    {/*{*/}
                                                    {/*    (itemChecked === false && (user.grassCutter === 'ON')) ? (*/}
                                                    {/*        <input*/}
                                                    {/*            type="radio"*/}
                                                    {/*            id={user.robotID + "-GCOn"}*/}
                                                    {/*            name={user.robotID + "-GC"}*/}
                                                    {/*            value="1"*/}
                                                    {/*            checked="true"*/}
                                                    {/*        />*/}
                                                    {/*    ) : (*/}
                                                    {/*        <input*/}
                                                    {/*            type="radio"*/}
                                                    {/*            id={user.robotID + "-GCOn"}*/}
                                                    {/*            name={user.robotID + "-GC"}*/}
                                                    {/*            value="1"*/}
                                                    {/*        />*/}
                                                    {/*    )*/}
                                                    {/*}*/}

                                                    {/*<span>&nbsp;On&nbsp;&nbsp;</span>*/}
                                                    {/*{(itemChecked === false && (user.grassCutter === "OFF")) ? (*/}
                                                    {/*    <input*/}
                                                    {/*        type="radio"*/}
                                                    {/*        id={user.robotID + '-GCOff'}*/}
                                                    {/*        name={user.robotID + "-GC"}*/}
                                                    {/*        value="0"*/}
                                                    {/*        checked="true"*/}
                                                    {/*    />*/}
                                                    {/*) : (*/}
                                                    {/*    <input*/}
                                                    {/*        type="radio"*/}
                                                    {/*        id={user.robotID + '-GCOff'}*/}
                                                    {/*        name={user.robotID + "-GC"}*/}
                                                    {/*        value="0"*/}
                                                    {/*    />*/}
                                                    {/*)*/}
                                                    {/*}*/}
                                                    {/*<span>&nbsp;Off&nbsp;&nbsp;</span>*/}
                                                </div>
                                            </div>
                                            <div className="row gc-sp-text" id={"dvgcsp" + user.robotID} style={{ display: "block" }}>
                                                {/*  <div className="col-sm-2 col_gc_sp1"> SP:&nbsp;</div>*/}
                                                <div className="col col_gc_sp1" key={user.robotID + 'divSPToggle'} id={user.robotID + 'divSPToggle'}>
                                                    {/*{(itemChecked === false && (user.sprayer === 'ON')) ? (*/}
                                                    {/*    <input style={{*/}
                                                    {/*        color: '#99cc33'*/}
                                                    {/*    }}*/}
                                                    {/*        type="radio"*/}
                                                    {/*        id={user.robotID + "-SPOn"}*/}
                                                    {/*        name={user.robotID + "-SP"}*/}
                                                    {/*        value="1"*/}
                                                    {/*        checked="true"*/}
                                                    {/*       />*/}
                                                    {/*) : (*/}
                                                    {/*    <input style={{*/}
                                                    {/*        color: '#99cc33'*/}
                                                    {/*    }}*/}
                                                    {/*        type="radio"*/}
                                                    {/*        id={user.robotID + "-SPOn"}*/}
                                                    {/*        name={user.robotID + "-SP"}*/}
                                                    {/*        value="1"*/}
                                                    {/*    />*/}
                                                    {/*)*/}
                                                    {/*}*/}
                                                    {/*<span>&nbsp;On&nbsp;&nbsp;</span>*/}
                                                    {/*{(itemChecked === false && (user.sprayer === 'OFF')) ? (*/}
                                                    {/*    <input*/}
                                                    {/*        type="radio"*/}
                                                    {/*        id={user.robotID + "-SPOff"}*/}
                                                    {/*        name={user.robotID + "-SP"}*/}
                                                    {/*        value="0"*/}
                                                    {/*        checked="true"*/}

                                                    {/*    />*/}
                                                    {/*) : (*/}
                                                    {/*    <input*/}
                                                    {/*        type="radio"*/}
                                                    {/*        id={user.robotID + "-SPOff"}*/}
                                                    {/*        name={user.robotID + "-SP"}*/}
                                                    {/*        value="0"*/}
                                                    {/*    />*/}
                                                    {/*)*/}
                                                    {/*}*/}
                                                    {/*<span>&nbsp;Off&nbsp;&nbsp;</span>*/}
                                                </div>
                                            </div>
                                            <div id={"dvmodal" + user.robotID} className="modalcontainer rb-pop">
                                                <Modal.Dialog size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                                                    <Modal.Header closeButton onClick={() => get_control_panel("dvmodal" + user.robotID)}>
                                                        <Modal.Title>Robot Operations</Modal.Title>
                                                    </Modal.Header>

                                                    <Modal.Body>

                                                        {/* ---------------- Row 2 : Tank Level + Uptime ---------------- */}
                                                        <div className="col-12 mt-1 watertl">

                                                            {/* ---------------- Row 2 : Tank Level + Uptime ---------------- */}
                                                            <div className="row align-items-center mt-2">

                                                                {/* Tank Level */}
                                                                <div
                                                                    className="col-12 col-sm-5 mb-2 d-flex align-items-center gap-2 gc-sp-text"
                                                                    id={user.robotID + "divTanlLevel"}
                                                                >
                                                                    <strong>Tank Level:</strong>
                                                                    <TankLevel tankLevel={user.waterTankLevelStatus} />
                                                                </div>

                                                                {/* Uptime */}
                                                                <div
                                                                    className="col-12 col-sm-7 mb-2 gc-sp-text"
                                                                    id={user.robotID + "divOperationTime"}
                                                                >
                                                                    <div className="text-sm-end d-flex justify-content-sm-end align-items-center gap-1">
                                                                        {/*<strong>*/}
                                                                        {/*    <i className="fa fa-history" style={{ color: "#000" }}></i>&nbsp;Uptime:*/}
                                                                        {/*</strong>*/}
                                                                        {connectedAt[String(user.robotID)] ? (
                                                                            <div className="rb-uptime" title="Time since this robot connected">
                                                                                <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                                                <span>Connected</span>
                                                                                <ConnectedTimer since={connectedAt[String(user.robotID)]} />
                                                                            </div>
                                                                        ) : (user.broadcastStatus === "Connected" ? (
                                                                            <div className="rb-uptime rb-uptime-idle"><i className="fa fa-circle" aria-hidden="true"></i><span>Connected</span></div>
                                                                        ) : null)}
                                                                        {/*<RobotRow key={user.robotID} robot={user} />*/}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        {/* --- GC/SP/SO row (stable, responsive) --- */}
                                                        <div className="row gc-sp-text" id={"dvgcsp1" + user.robotID}>

                                                            <div className="col-12">
                                                                <div className="row align-items-center" style={{ marginTop: 6 }}>

                                                                    {/* GC */}
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center mb-2">
                                                                        <span className="gc-sp-text me-2">GC:</span>
                                                                        <div className="d-flex align-items-center">
                                                                            <input
                                                                                className="react-switch-checkbox"
                                                                                id={user.robotID + "GC1InputToggle"}
                                                                                name={user.robotID + "GC1InputToggle"}
                                                                                key={user.robotID + "GC1InputToggle"}
                                                                                type="checkbox"
                                                                                checked={user.grasscutterselected}
                                                                                onChange={(e) => onGrassCutterCheck(e, user)}
                                                                            />
                                                                            <label
                                                                                key={user.robotID + "lblGC1"}
                                                                                id={user.robotID + "lblGC1"}
                                                                                style={{ background: user.grasscutterselected ? "#99cc33" : "lightgray" }}
                                                                                className="react-switch-label ms-1"
                                                                                htmlFor={user.robotID + "GC1InputToggle"}
                                                                            >
                                                                                <span
                                                                                    id={user.robotID + "GC1span"}
                                                                                    name={user.robotID + "GC1span"}
                                                                                    key={user.robotID + "GCspan"}
                                                                                    className="react-switch-button"
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    {/* SP */}
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center mb-2">
                                                                        <span className="gc-sp-text me-2">SP:</span>
                                                                        <div className="d-flex align-items-center">
                                                                            <input
                                                                                className="react-switch-checkbox"
                                                                                id={user.robotID + "SP1InputToggle"}
                                                                                name={user.robotID + "SP1InputToggle"}
                                                                                key={user.robotID + "SP1InputToggle"}
                                                                                type="checkbox"
                                                                                checked={user.sprayerselected}
                                                                                onChange={(e) => onSprayerCheck(e, user)}
                                                                            />
                                                                            <label
                                                                                key={user.robotID + "lblSP1"}
                                                                                id={user.robotID + "lblSP1"}
                                                                                style={{ background: user.sprayerselected ? "#99cc33" : "lightgray" }}
                                                                                className="react-switch-label ms-1"
                                                                                htmlFor={user.robotID + "SP1InputToggle"}
                                                                            >
                                                                                <span
                                                                                    id={user.robotID + "SP1span"}
                                                                                    name={user.robotID + "SPspan"}
                                                                                    key={user.robotID + "span"}
                                                                                    className="react-switch-button"
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    {/* SO */}
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center mb-2">
                                                                        <span className="gc-sp-text me-2">SO:</span>
                                                                        <div className="d-flex align-items-center">
                                                                            <input
                                                                                className="react-switch-checkbox"
                                                                                id={user.robotID + "SO1InputToggle"}
                                                                                name={user.robotID + "SO1InputToggle"}
                                                                                key={user.robotID + "SO1InputToggle"}
                                                                                type="checkbox"
                                                                                checked={user.sowingselected}
                                                                                onChange={(e) => onSowingCheck(e, user)}
                                                                            />
                                                                            <label
                                                                                key={user.robotID + "lblSO1"}
                                                                                id={user.robotID + "lblSO1"}
                                                                                style={{ background: user.sowingselected ? "#99cc33" : "lightgray" }}
                                                                                className="react-switch-label ms-1"
                                                                                htmlFor={user.robotID + "SO1InputToggle"}
                                                                            >
                                                                                <span
                                                                                    id={user.robotID + "SO1span"}
                                                                                    name={user.robotID + "SO1span"}
                                                                                    key={user.robotID + "span"}
                                                                                    className="react-switch-button"
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    {/* optional placeholders kept (non-collapsing) */}
                                                                    <div className="col-12 col-sm-3 mb-2 d-none d-sm-block">
                                                                        {/* reserved for future controls / spacing */}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                        {/* --- Video / gauges / iframe area --- */}
                                                        <div className="col container_multi_robots" style={{ position: "relative", backgroundColor: "aliceblue" }}>
                                                            {user.controllerBatteryStatus ? (
                                                                <div className="dvcb1 col" id={"dvCB" + user.robotID} style={{ zIndex: 1200 }}>
                                                                    CB&nbsp;
                                                                    <BatteryGauge className="controllerbattery1" id={"CB" + user.robotID} value={user.controllerBatteryStatus}
                                                                        customization={{
                                                                            batteryMeter: {
                                                                                fill: getBatteryColor(user.controllerBatteryStatus),
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div className="dvcb1 col" id={"dvCB1" + user.robotID} style={{ zIndex: 1200 }}>
                                                                    CB&nbsp;
                                                                    <BatteryGauge className="controllerbattery1" id={"CB1" + user.robotID} value={0}
                                                                        customization={{
                                                                            batteryMeter: {
                                                                                fill: getBatteryColor(0),
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}

                                                            {user.motorBatteryStatus ? (
                                                                <div className="dvmb1 col" id={"dvMB" + user.robotID}>
                                                                    MB&nbsp;
                                                                    <BatteryGauge className="motorbattery1" id={"MB2" + user.robotID} value={user.motorBatteryStatus}
                                                                        customization={{
                                                                            batteryMeter: {
                                                                                fill: getBatteryColor(user.motorBatteryStatus),
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div className="dvmb1 col" id={"dvMB1" + user.robotID}>
                                                                    MB&nbsp;
                                                                    <BatteryGauge className="motorbattery1" id={"MB3" + user.robotID} value={0}
                                                                        customization={{
                                                                            batteryMeter: {
                                                                                fill: getBatteryColor(0),
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}

                                                            {IPAddress && activeCameraRobotId === user.robotID ? (
                                                                //<Iframe
                                                                //    id={"Iframe3" + user.robotID}
                                                                //    key={"Iframe1" + user.robotID}
                                                                //    url={`${PI_SERVER_URL}/`}
                                                                //    className="responsive-iframe_1 inneriframe1"
                                                                //    loading="lazy"
                                                                //    allow="microphone;camera"
                                                                ///>
                                                                <video
                                                                    id={"Iframe3" + user.robotID}
                                                                    key={"Iframe1" + user.robotID}
                                                                    ref={videoModalRef}
                                                                    autoPlay
                                                                    playsInline
                                                                    controls
                                                                    className="pi-viewer__video responsive-iframe_1 inneriframe1"
                                                                    style={{ objectFit: 'contain', width: '100%', height: '100%', background: '#000' }}
                                                                />
                                                            ) : (
                                                                <Iframe
                                                                    id={"Iframe4" + user.robotID}
                                                                    key={"Iframe2" + user.robotID}
                                                                    url={robot_operation}
                                                                    className="responsive-iframe_1 inneriframe1"
                                                                    loading="lazy"
                                                                    allow="microphone;camera"
                                                                />
                                                            )}

                                                            {/* robot name, power lights and control panel */}
                                                            <div style={{ marginTop: "55%", backgroundColor: "#ffffff", marginLeft: "40%", fontSize: "120%" }}>
                                                                <div className="display_robot_name">{user.robotName}</div>

                                                                <div id={"dvPL" + user.robotID} className="PowerLight">
                                                                    {user.currentCommandStatus === "OFF" && <div id={"PL" + user.robotID}><PowerLight state={user.towerlampstatus} /></div>}
                                                                    {(user.currentCommandStatus === "S" || user.currentCommandStatus === "New") && <div id={"PL" + user.robotID}><PowerLight state={user.towerlampstatus} /></div>}
                                                                    {(
                                                                        user.currentCommandStatus === "Moving Forward" ||
                                                                        user.currentCommandStatus === "Moving Backward" ||
                                                                        user.currentCommandStatus === "Forward Left" ||
                                                                        user.currentCommandStatus === "Backward Left" ||
                                                                        user.currentCommandStatus === "Forward Right" ||
                                                                        user.currentCommandStatus === "Backward Right"
                                                                    ) && <div id={"PL" + user.robotID}><PowerLight state={user.towerlampstatus} /></div>}
                                                                </div>

                                                                <div key={"keydv" + user.robotID} id={"dvid" + user.robotID} className="control_panel" style={{ display: "block", backgroundColor: "#ffffff" }}>
                                                                    {/* control buttons (kept exactly as you wrote) */}
                                                                    <div className="icon-forward-2" id={"divStart_1" + user.robotID}>
                                                                        <a id={"btnStart_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("F", "D", "btnStart_1" + user.robotID, user.robotID, "divStart_1" + user.robotID, e)}>
                                                                            <i className="fa fa-caret-square-o-up" style={{ color: "#cae00d" }}></i> F
                                                                        </a>
                                                                    </div>

                                                                    <div id={"divReturn_1" + user.robotID} className="icon-backward-2">
                                                                        <a id={"btnReturn_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("B", "D", "btnReturn_1" + user.robotID, user.robotID, "divReturn_1" + user.robotID, e)}>
                                                                            <i className="fa fa-caret-square-o-down" style={{ color: "#cae00d" }}></i> B
                                                                        </a>
                                                                    </div>

                                                                    <div id={"divLeft_1" + user.robotID} className="icon-left">
                                                                        <a id={"btnLeft_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("None", "L", "btnLeft_1" + user.robotID, user.robotID, "divLeft_1" + user.robotID)} onTouchStart={(e) => send_command_to_selected_robots("None", "L", "btnLeft_1" + user.robotID, user.robotID, "divLeft_1" + user.robotID, e)} onTouchEnd={handleTouchEnd}>
                                                                            <i className="fa fa-caret-square-o-left" style={{ color: "#cae00d" }}></i> L
                                                                        </a>
                                                                    </div>

                                                                    <div id={"divRight_1" + user.robotID} className="icon-right">
                                                                        <a id={"btnRight_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("None", "R", "btnRight_1" + user.robotID, user.robotID, "divRight_1" + user.robotID)} onTouchStart={(e) => send_command_to_selected_robots("None", "R", "btnRight_1" + user.robotID, user.robotID, "divRight_1" + user.robotID, e)} onTouchEnd={handleTouchEnd}>
                                                                            R&nbsp;<i className="fa fa-caret-square-o-right" style={{ color: "#cae00d" }}></i>
                                                                        </a>
                                                                    </div>

                                                                    <div id={"divTurnStop_1" + user.robotID} className="icon-turn_stop-2">
                                                                        <a id={"btnTurnStop_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("None", "D", "btnTurnStop_1" + user.robotID, user.robotID, "divTurnStop_1" + user.robotID, e)}>
                                                                            <i className="fa fa-dot-circle-o" style={{ color: "#cae00d" }}></i>&nbsp;S
                                                                        </a>
                                                                    </div>

                                                                    <div id={"divForwardRight_1" + user.robotID} className="icon-forward-right">
                                                                        <a id={"btnForwardRight_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("F", "R", "btnForwardRight_1" + user.robotID, user.robotID, "divForwardRight_1" + user.robotID, e)}>
                                                                            FR&nbsp;<i className="fa fa-share" style={{ color: "#cae00d" }}></i>
                                                                        </a>
                                                                    </div>

                                                                    <div id={"divForwardLeft_1" + user.robotID} className="icon-forward-left">
                                                                        <a id={"btnForwardLeft_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("F", "L", "btnForwardLeft_1" + user.robotID, user.robotID, "divForwardLeft_1" + user.robotID, e)}>
                                                                            <i className="fa fa-reply" style={{ color: "#cae00d" }}></i> FL
                                                                        </a>
                                                                    </div>

                                                                    <div id={"divBackwardRight_1" + user.robotID} className="icon-backward-right-2">
                                                                        <a id={"btnBackwardRight_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("B", "R", "btnBackwardRight_1" + user.robotID, user.robotID, "divBackwardRight_1" + user.robotID, e)}>
                                                                            BR&nbsp;<i className="fa fa-reply fa-rotate-180" style={{ color: "#cae00d" }}></i>
                                                                        </a>
                                                                    </div>

                                                                    <div id={"divBackwardLeft_1" + user.robotID} className="icon-backward-left-2">
                                                                        <a id={"btnBackwardLeft_1" + user.robotID} className="operation-icon" onClick={(e) => send_command_to_selected_robots("B", "L", "btnBackwardLeft_1" + user.robotID, user.robotID, "divBackwardLeft_1" + user.robotID, e)}>
                                                                            <i className="fa fa-share fa-rotate-180" style={{ color: "#cae00d" }}></i> BL
                                                                        </a>
                                                                    </div>

                                                                </div>

                                                                {/*{user.broadcastStatus === "Disconnected" ? (*/}
                                                                {/*    <div id={"divConnect_1" + user.robotID} className="icon-connect_3 modal-icon-size1 connection_status1">*/}
                                                                {/*        <a id={"btnConnect_1" + user.robotID} className="modal_connect_stop_link" onClick={() => Create_broadcasting_command_message("btnConnect_1" + user.robotID, user.robotID, "divConnect_1" + user.robotID)}>*/}
                                                                {/*            <i className="fa fa-toggle-off" style={{ color: "#cae00d" }}></i> Connect*/}
                                                                {/*        </a>*/}
                                                                {/*    </div>*/}
                                                                {/*) : (*/}
                                                                {/*    <div id={"divConnect_1" + user.robotID} className="icon-connect_3 modal-icon-size1 connection_status1">*/}
                                                                {/*        <a id={"btnConnect_1" + user.robotID} className="modal_connect_stop_link" onClick={() => Create_broadcasting_command_message("btnConnect_1" + user.robotID, user.robotID, "divConnect_1" + user.robotID)}>*/}
                                                                {/*            <i className="fa fa-toggle-on" style={{ color: "#FB4F14" }}></i> Disconnect*/}
                                                                {/*        </a>*/}
                                                                {/*    </div>*/}
                                                                {/*)}*/}

                                                                {/*<div id={"divRobotStop_1" + user.robotID} className="icon-stop-3 modal-icon-size1">*/}
                                                                {/*    <a id={"btnRobotStop_1" + user.robotID} className="modal_connect_stop_link" onClick={() => stop_selected_robots("btnRobotStop_1" + user.robotID, user.robotID, "divRobotStop_1" + user.robotID)}>*/}
                                                                {/*        <i className="fa fa-circle-o-notch" style={{ color: "#cae00d" }}></i> Stop*/}
                                                                {/*    </a>*/}
                                                                {/*</div>*/}

                                                            </div>
                                                        </div>

                                                        {/* ---------------- Row 1 : Connect + Stop ---------------- */}
                                                        {/* Same ids / same element structure as before (Create_broadcasting_command_message rewrites btnConnect_1* innerHTML),
                                                            only the look changed: normal buttons in their own row instead of grey pills laid over the camera. */}
                                                        <div className="rb-pop-actions">

                                                            {/* Connect Button */}
                                                            <div id={"divConnect_1" + user.robotID}>
                                                                {user.broadcastStatus === "Disconnected" ? (
                                                                    <button
                                                                        type="button"
                                                                        id={"btnConnect_1" + user.robotID}
                                                                        className="rb-btn rb-green"
                                                                        onClick={() => {
                                                                            Create_broadcasting_command_message(
                                                                                "btnConnect_1" + user.robotID,
                                                                                user.robotID,
                                                                                "divConnect_1" + user.robotID
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-plug"></i>
                                                                        Connect
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        id={"btnConnect_1" + user.robotID}
                                                                        className="rb-btn rb-green rb-active"
                                                                        onClick={() => {
                                                                            Create_broadcasting_command_message(
                                                                                "btnConnect_1" + user.robotID,
                                                                                user.robotID,
                                                                                "divConnect_1" + user.robotID
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-plug"></i>
                                                                        Disconnect
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {/* Stop Button */}
                                                            <div id={"divRobotStop_1" + user.robotID}>
                                                                <button
                                                                    type="button"
                                                                    id={"btnRobotStop_1" + user.robotID}
                                                                    className="rb-btn rb-red"
                                                                    onClick={() =>
                                                                        stop_selected_robots(
                                                                            "btnRobotStop_1" + user.robotID,
                                                                            user.robotID,
                                                                            "divRobotStop_1" + user.robotID
                                                                        )
                                                                    }
                                                                >
                                                                    <i className="fa fa-stop-circle"></i>
                                                                    Stop
                                                                </button>
                                                            </div>

                                                        </div>

                                                    </Modal.Body>



                                                    <Modal.Footer>
                                                        <div className="w-100 d-flex flex-wrap gap-2 justify-content-between align-items-center">

                                                            {/* Camera */}
                                                            <div className="icon-camera-3 modal-icon-size1" id={"divCamera_" + user.robotID}>
                                                                <a
                                                                    id={"btnCamera_" + user.robotID}
                                                                    className="modal_connect_stop_link d-flex align-items-center rb-pill"
                                                                    onClick={() => {
                                                                        const isThisRobotCameraOn = isCameraOn && activeCameraRobotId === user.robotID;

                                                                        if (isThisRobotCameraOn) {
                                                                            stopViewing();
                                                                            setIsCameraOn(false);
                                                                            setActiveCameraRobotId(null);
                                                                        } else {
                                                                            if (isCameraOn) {
                                                                                stopViewing();
                                                                            }
                                                                            setActiveCameraRobotId(user.robotID);
                                                                            startViewing();
                                                                            setIsCameraOn(true);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        textDecoration: "none",
                                                                        whiteSpace: "nowrap"
                                                                    }}
                                                                >
                                                                    <img id={"imgCamera_" + user.robotID}
                                                                        src={
                                                                            (isCameraOn && activeCameraRobotId === user.robotID)
                                                                                ? cameraon
                                                                                : cameraoff
                                                                        }
                                                                        alt={(isCameraOn && activeCameraRobotId === user.robotID) ? "Camera On" : "Camera Off"}
                                                                        style={{
                                                                            width: "34px",
                                                                            height: "34px",
                                                                            objectFit: "contain",
                                                                            marginRight: "0px"
                                                                        }}
                                                                    />

                                                                    {(isCameraOn && activeCameraRobotId === user.robotID) ? "Off" : "On"}
                                                                </a>
                                                            </div>

                                                            {/* Joystick */}
                                                            <div className="icon-camera-3 modal-icon-size1">
                                                                <a
                                                                    id={"btnJoystick_" + user.robotID}
                                                                    className="modal_connect_stop_link d-flex align-items-center rb-pill"
                                                                    onClick={() => JoystickRobotOperation(
                                                                        user.robotID
                                                                    )
                                                                    }
                                                                    title="Robot Operations"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        textDecoration: "none",
                                                                        whiteSpace: "nowrap"
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="fa fa-gamepad"
                                                                        style={{ marginRight: "6px" }}
                                                                    ></i>

                                                                    Use Joystick
                                                                </a>
                                                            </div>

                                                        </div>
                                                    </Modal.Footer>
                                                </Modal.Dialog>
                                            </div>



                                            <div id={"dvInfoBox" + user.robotID} class="modalcontainer">
                                                <Modal.Dialog size="lg"
                                                    aria-labelledby="contained-modal-title-vcenter"
                                                    centered
                                                >
                                                    <Modal.Header closeButton onClick={() => hideInfoBox("dvInfoBox" + user.robotID)}>
                                                        <Modal.Title>
                                                            Information Box
                                                        </Modal.Title>
                                                    </Modal.Header>

                                                    <Modal.Body>
                                                        <p>
                                                            <label id={"lblCriticalMessage" + user.robotID}></label>
                                                        </p>
                                                        <p>&nbsp;</p>
                                                        <div key={"dvInfoCommand" + user.robotID} id={"dvInfoCommand" + user.robotID} class="control_panel" style={{ display: "block", backgroundColor: "#ffffff" }}>
                                                            <div id={"divInfoRobotStop_1" + user.robotID} className="icon-stop-3 modal-icon-size1">
                                                                <a id={"btnInfoRobotStop_1" + user.robotID} class="modal_connect_stop_link" onClick={() => stop_selected_robots("btnInfoRobotStop_1" + user.robotID, user.robotID, "divRobotStop_1" + user.robotID)} ><i class="fa fa-circle-o-notch" style={{ color: '#cae00d' }}></i>Stop Robot</a>
                                                            </div>
                                                            <div id={"divInfoReturnToStation" + user.robotID} className="icon-stop-3 modal-icon-size1">
                                                                <a id={"btnInfoReturnToStation" + user.robotID} class="modal_connect_stop_link" onClick={() => stop_selected_robots("btnInfoReturnToStation" + user.robotID, user.robotID, "divInfoReturnToStation" + user.robotID)} ><i class="fa fa-plug" style={{ color: '#cae00d' }}></i>Charging</a>
                                                            </div>
                                                            <div className="col" id={"divInfooff" + user.robotID}>
                                                                <a style={{ cursor: 'Pointer', color: '#A0A0A0' }} id={"btnInfooff" + user.robotID} onClick={() => send_command_to_selected_robots("OFF")}><i class="fa fa-power-off operation-icon" id="off-icon" style={{ fontSize: "40px" }}></i>Robot Operation Stop</a>
                                                            </div>


                                                            {/*<p><RobotLocation></RobotLocation></p>*/}
                                                        </div>
                                                    </Modal.Body>

                                                </Modal.Dialog>

                                            </div>

                                        </div>
                                    ];
                                }
                                )
                                }
                            </div>
                            <p></p>

                            <div id="dvInfoBox" class="modalcontainer">
                                <Modal.Dialog size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                >
                                    <Modal.Header closeButton onClick={() => hideInfoBox("dvInfoBox")}>
                                        <Modal.Title>
                                            Warning Box
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <p>
                                            <label id={"lblCriticalMsg"}></label>
                                        </p>
                                        <p>&nbsp;</p>
                                    </Modal.Body>
                                </Modal.Dialog>
                            </div>
                            <p></p>
                            {/*<div className="row">*/}
                            {/*    <div className="col" id={"divStart"+0}>*/}
                            {/*        <a style={{ cursor: 'Pointer', color: '#A0A0A0' }} id={"btnStart"+0} onClick={(e) => send_command_to_selected_robots("F", "D")} ><i class="fa fa-caret-square-o-up operation-icon" id="forward-icon" style={{fontSize: "40px"} }></i>Forward</a>*/}
                            {/*    </div>*/}
                            {/*    <div className="col" id={"divReturn"+0}>*/}
                            {/*        <a style={{ cursor: 'Pointer', color: '#A0A0A0' }} id={"btnReturn" + 0} onClick={(e) => send_command_to_selected_robots("B", "D")} ><i class="fa fa-caret-square-o-down operation-icon" id="backward-icon" style={{ fontSize: "40px" }}></i>Backward</a>*/}
                            {/*    </div>*/}

                            {/*    <div className="col" id={"divLeft"+0}>*/}
                            {/*        <a style={{ cursor: 'Pointer', color: '#A0A0A0' }} id={"btnLeft" + 0} onClick={(e) => send_command_to_selected_robots("None", "L")} ><i class="fa fa-caret-square-o-left operation-icon" id="left-icon" style={{ fontSize: "40px" }}></i>Left</a>*/}
                            {/*    </div>*/}

                            {/*    <div className="col" id={"divTurnStop"+0}>*/}
                            {/*        <a style={{cursor: 'Pointer', color:'#A0A0A0'}} id={"btnTurnStop" + 0} onClick={(e) => send_command_to_selected_robots("None", "D")} ><i class="fa fa-dot-circle-o operation-icon" id="turn-icon" style={{ fontSize: "40px" }}></i>Stop Turn</a>*/}
                            {/*    </div>*/}

                            {/*    <div className="col" id={"divRight"+0}>*/}
                            {/*        <a style={{cursor: 'Pointer', color:'#A0A0A0'}} id={"btnRight"+0} onClick={(e) => send_command_to_selected_robots("None", "R")} ><i class="fa fa-caret-square-o-right operation-icon" id="right-icon" style={{ fontSize: "40px" }}></i>Right</a>*/}
                            {/*    </div>*/}

                            {/*    <div className="col" id={"divStop" + 0}>*/}
                            {/*        <a style={{cursor:'Pointer', color:'#A0A0A0'}} id={"btnStop" + 0}  onClick={(e) => stop_selected_robots("btnStop",0,"divStop", e)}><i class="fa fa-circle-o-notch operation-icon" id="stop-icon" style={{ fontSize: "40px" }}></i>Stop</a>*/}
                            {/*    </div>*/}

                            {/*    <div className="col" id={"divoff" + 0}>*/}
                            {/*        <a style={{ cursor: 'Pointer', color: '#A0A0A0' }} id={"btnoff" + 0} onClick={() => send_command_to_selected_robots("OFF")}><i class="fa fa-power-off operation-icon" id="off-icon" style={{ fontSize: "40px" }}></i>Off</a>*/}
                            {/*    </div>*/}
                            {/*    <p></p>*/}
                            {/*    */}{/*<div className="row">*/}
                            {/*    */}{/*  <div className="column">*/}
                            {/*    */}{/*        <RobotLocation ang={angle} lat={latitude} lon={longitude} fid={rID}></RobotLocation>*/}
                            {/*    */}{/*  </div>*/}
                            {/*    */}{/*</div>*/}
                            {/*</div>*/}

                            {/* ---------------------- STICKY CONTROL DOCK (stays at the bottom of the screen while you scroll the cameras) ------------------------ */}
                            {/* extra page room (outside the popup, no white space inside it) so a popup near the end of the list can be scrolled fully above the dock */}
                            {isModalOpen && <div aria-hidden="true" style={{ height: dockHeight }} />}
                            <RobotControlDock {...barProps} />



                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};